import React from "react"
export function CoworkingContent(props) {
  switch (props.city) {
    case "Bengaluru":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>Coworking Spaces in Bangalore</h2>
          <p>
            Bangalore, India's Silicon Valley, is a thriving hub for coworking
            spaces, catering to the diverse needs of startups, freelancers, and
            established companies. These spaces offer a dynamic and
            collaborative environment, fostering innovation and networking.
            Equipped with modern amenities, high-speed internet, and flexible
            seating options, they provide an ideal setting for productivity and
            creativity.{" "}
          </p>
          <p>
            Located across the city, these coworking spaces are easily
            accessible and situated near key commercial areas, making them
            highly sought after by professionals seeking a vibrant work
            atmosphere.
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Average Day Pass Cost in Bengaluru
          </h3>
          <p>
            The cost of a day pass for coworking spaces in Bengaluru varies
            widely, depending on the location and facilities offered. At
            GoFloaters, the prices range from affordable (99Rs/day) to premium,
            making coworking spaces accessible for different budget
            requirements. This pricing flexibility allows individuals and
            businesses to choose spaces that align with their financial and
            professional needs, ensuring they can benefit from the collaborative
            and resource-rich environment of coworking spaces in Bengaluru.
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Best Locations for Coworking Spaces in Bangalore
          </h3>
          <p>
            1.{" "}
            <a href="https://gofloaters.com/coworking-spaces/bengaluru/all?locality=Residency%20Road">
              Coworking spaces in Central Business District
            </a>{" "}
            (CBD)
            <br />
            The CBD of Bengaluru is the epicenter of business and commerce,
            making it a coveted location for coworking spaces. These spaces are
            often equipped with high-end amenities and offer unparalleled
            networking opportunities with leading business professionals and
            entrepreneurs. The area's vibrant atmosphere, coupled with its
            proximity to key commercial establishments, government offices, and
            luxury retail, makes it an ideal spot for businesses seeking
            prestige and connectivity.
          </p>
          <p>
            2.{" "}
            <a href="https://gofloaters.com/coworking-spaces/bengaluru/all?locality=Koramangala">
              Coworking spaces in Koramangala
            </a>
            <br />
            Koramangala is renowned for its eclectic mix of startups, boutiques,
            and cafes, making it a hotspot for creative and entrepreneurial
            minds. Coworking spaces here are characterized by their innovative
            design and community-focused ethos, providing a nurturing
            environment for collaboration and ideation. The area's youthful vibe
            and its status as a startup nucleus make it an ideal locale for
            budding entrepreneurs and freelancers looking for inspiration and
            community support.
          </p>
          <p>
            3.{" "}
            <a href="https://gofloaters.com/coworking-spaces/bengaluru/all?locality=Indiranagar">
              Coworking spaces in Indiranagar
            </a>
            <br />
            Indiranagar, known for its lively nightlife and bustling streets, is
            also a prime location for coworking due to its blend of modernity
            and accessibility. The coworking spaces here attract a diverse
            professional crowd, from digital nomads to established businesses,
            offering a dynamic and collaborative working environment. The area's
            connectivity to other major parts of the city, along with a plethora
            of dining and leisure options, adds to its appeal as a coworking
            destination.
          </p>
          <p>
            4.{" "}
            <a href="https://gofloaters.com/coworking-spaces/bengaluru/all?locality=Whitefield">
              Coworking spaces in Whitefield
            </a>
            <br />
            As a leading IT hub, Whitefield is home to numerous tech parks and
            multinational corporations, making it an ideal location for
            tech-focused coworking spaces. These spaces are tailored to meet the
            needs of tech companies and professionals, equipped with
            cutting-edge technology, high-speed internet, and collaborative work
            zones. Its reputation as an IT center attracts a vibrant community
            of tech entrepreneurs, developers, and innovators.
          </p>
          <p>
            5.{" "}
            <a href="https://gofloaters.com/coworking-spaces/bengaluru/all?locality=HSR%20Layout">
              Coworking spaces in HSR Layout
            </a>
            <br />
            HSR Layout is popular among startups due to its relatively
            affordable real estate and a thriving entrepreneurial ecosystem.
            Coworking spaces here offer flexible work arrangements, networking
            events, and incubation support, catering to the needs of young
            startups and individual entrepreneurs. The area's growing reputation
            as a startup hub, combined with its well-planned layout and
            amenities, makes it an attractive location for coworking.
          </p>
          <p>
            6. Coworking spaces in Electronic City
            <br />
            Known as the Silicon Valley of India, Electronic City's coworking
            spaces are predominantly occupied by tech companies and
            professionals. These spaces are designed to support high-tech work
            with robust IT infrastructure, dedicated tech support, and modern
            facilities. The area's concentration of IT companies and tech
            professionals creates a synergistic environment, ideal for tech
            startups and IT consultants.
          </p>
          <p>
            7.{" "}
            <a href="https://gofloaters.com/coworking-spaces/bengaluru/all?locality=Jayanagar">
              Coworking spaces in Jayanagar
            </a>
            <br />
            Jayanagar, one of Bengaluru's older residential areas, offers a
            serene and focused coworking environment. The coworking spaces here
            blend traditional charm with modern facilities, attracting
            freelancers, writers, and small teams seeking a tranquil workspace
            away from the bustle of the city. The area's well-established
            infrastructure, parks, and cultural spots add to its charm as a
            coworking destination.
          </p>
          <p>
            8. Coworking spaces in Bannerghatta Road
            <br />
            This location is known for its vast, state-of-the-art coworking
            spaces that cater to businesses of all sizes. The area's rapid
            development and proximity to several educational institutions and
            tech parks make it an ideal spot for businesses seeking growth and
            scalability. The availability of large spaces allows for
            customizable offices, making it suitable for companies looking to
            establish a significant presence.
          </p>
          <p>
            9.{" "}
            <a href="https://gofloaters.com/coworking-spaces/bengaluru/all?locality=Marathahalli">
              Coworking spaces in Marathahalli
            </a>
            <br />
            Marathahalli's strategic location and affordability make it a
            popular choice for startups and small businesses. The coworking
            spaces here provide essential amenities and are well-connected to
            the rest of the city, offering a practical and cost-effective
            solution for those starting out or operating on a tight budget.
          </p>
          <p>
            10.{" "}
            <a href="https://gofloaters.com/coworking-spaces/bengaluru/all?locality=MG%20Road">
              Coworking spaces in MG Road
            </a>
            <br />
            MG Road stands out for its prime location and accessibility,
            surrounded by business centers, retail outlets, and entertainment
            zones. Coworking spaces here are preferred by businesses and
            professionals who prioritize convenience and a prestigious address.
            The area's blend of modernity, heritage, and bustling city life
            makes it an attractive coworking spot for those seeking an energetic
            and inspiring work environment.
          </p>
          <p>
            Each of these locations in Bengaluru offers unique advantages,
            catering to the varied preferences and requirements of the city's
            diverse professional community.
          </p>
          <p>
            <strong>
              Why Book Coworking Spaces in Bengaluru on GoFloaters?
            </strong>
            <br />
            Booking coworking spaces in Bengaluru through GoFloaters offers
            several advantages. The platform provides a comprehensive list of
            diverse coworking options across the city, catering to various
            preferences and budgets. GoFloaters' user-friendly interface makes
            finding and booking spaces convenient and efficient. Additionally,
            the platform ensures transparency in pricing and often provides
            competitive rates and flexible booking options.{" "}
          </p>
          <p>
            With GoFloaters, users can access spaces that are not only
            cost-effective but also adhere to quality standards and necessary
            amenities, making it an ideal choice for professionals and
            businesses in Bengaluru.
          </p>
        </div>
      )
    case "Ahmedabad":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Find top coworking space in Ahmedabad
          </h2>{" "}
          <p>
            <b>The Magnificent City of Ahmedabad</b>
            <br />
            Ahmedabad is one of the largest cities in Gujarat. It is the state’s
            former capital with many historical references prominent to the
            evolution of our nation, such as the Swadeshi movement, satyagraha,
            and so on. <br />
            <br />
            Today, Ahmedabad is an imperative economic, industrial, and cultural
            hub of India.
            <br />
            <br />
            Ahmedabad is home to some of the oldest commercial establishments
            alongside Mumbai. The city boasts of many first and largest
            establishments, including the first textile mill, Ahmedabad Spinning
            and Weaving Company Limited, Ahmedabad Stock Exchange, corporate
            headquarters of the Adani Group, Tata automotive units, Cadila
            Healthcare, AIA Engineering and many other large conglomerates,
            FMCG, pharmaceutical companies.
            <br />
            <br />
            Information technology and information technology-enabled services
            in the city (IT and ITes) have grown leaps and bounds. Most SME and
            IT service providers are engaged in outsourcing and project-based
            businesses. Companies have adapted to the new normal of work from
            home, work from anywhere or Hybrid world culture. This has created a
            win-win situation enabling high-quality talents across regions.
            <br />
            <br />
            <i>Fun Fact</i>
            <br />
            <br />
            <b>What has been THE most significant thing about Ahmedabad?</b>
            <br />
            <br />
            <a
              href="https://www.iima.ac.in/"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              <b>Indian Institute of Management – Ahmedabad</b>
            </a>
            <br />
            The IIM-A has arguably produced the most significant number of
            notable entrepreneurs, start-ups and innovations in the country, an
            institute that brings fame to India and its prodigies. Some brands
            include Naukri, make my trip, Rediff, Mphasis, Give India, and the
            list goes on.
            <br />
            <br />
            Ahmedabad also has some of the oldest and top-rated educational
            institutions, including Nirma, St.Xaviers, Ahmedabad university,
            which Gandhiji established.
            <br />
            <br />
            Maybe, it is the whiff of a state primarily known for being the best
            risk taker, courageous business owners and entrepreneurs in their
            nature that has produced some of the most prominent names in the
            business sector.
            <br />
            <br />
            <b>Coworking Spaces in Ahmedabad</b>
            <br />
            Many work from home or find the ideal coworking space in Ahmedabad
            around their neighbourhood. At GoFloaters, you will find the best
            coworking spaces in Ahmedabad, premium in quality but within an
            affordable range. Whether you are a distributed team, remote
            workforce, freelancer, independent professional or consultant
            part-timing, you are just a click away from getting the best deal.
            <br />
            <br />
            If you are just about to start out and looking for Hot Desk and
            Private Cabins that won’t make a hole in your wallet or eat up your
            monthly budget, then this is the page to read in. Find your kind of
            place and get working!
            <br />
            <br />
          </p>
        </div>
      )
    case "Goa":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Find World Class Coworking Space in Goa
          </h2>{" "}
          <p>
            Goa, the smallest state in India, is situated along the southwest
            coast. Known for its picturesque beaches and vibrant nightlife, Goa
            has a rich history influenced by its prolonged Portuguese colonial
            past.
            <br />
            <br />
            <b>Tropical Tech Paradise</b>
            <br />
            Over time, Goa has morphed from just a popular tourist destination
            to a budding hub for entrepreneurs and digital nomads. Originally
            cherished for its serene landscapes and laid-back lifestyle, Goa is
            now also recognized for its burgeoning tech and creative scene. As
            the digital revolution began to unfold, the appeal of Goa's balanced
            life—where one can work hard during the day and relax by the beach
            in the evening—became irresistible for many young professionals.
            <br />
            <br />
            Goa boasts of esteemed educational institutions such as the Goa
            Institute of Management (GIM), National Institute of Technology (NIT
            Goa), and Goa University. These institutions, alongside numerous
            reputable schools, cater to the state's dynamic population,
            contributing to Goa's unique blend of tradition and modernity.
            <br />
            <br />
            The entrepreneurial spirit is alive in Goa with a growing number of
            startups setting their roots here. This trend is driven not just by
            the local talent but also by professionals from across the country
            seeking a harmonious blend of work and leisure. While tourism
            remains a significant economic driver, sectors like IT, biotech, and
            creative arts are rapidly gaining ground.
            <br />
            <br />
            Embracing the Work from Anywhere (WFA) culture has become a natural
            progression for many in Goa. The perks of WFA in the Goan context
            include:
            <br />
            <br />
            <ul>
              <li>
                Freedom with Views - Work as per your rhythm, with the beach or
                the hinterlands as your backdrop.
              </li>
              <li>
                Serenity and Inspiration - Draw creativity from the tranquil
                surroundings and rich Goan culture.
              </li>

              <li>
                Perfect Work - Leisure Balance - After a productive day, indulge
                in Goa's multifaceted leisure activities.
              </li>
              <li>
                {" "}
                Boosted Productivity - In a place where relaxation meets
                motivation, witness an uptick in your work efficiency.
              </li>
            </ul>
            <br />
            <br />
          </p>
        </div>
      )
    case "Kochi":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>Best Coworking Space in Kochi</h2>{" "}
          <p>
            Kochi, derived from the word Kochazhi (small lagoon), is a place to
            some of the world’s finest harbours and spice trades. Rich in
            landscape and backwaters, Kochi provides the justification that
            Kerala needs to be God’s own country.
            <br />
            <br />
            Kochi is not just famous for its group of islands (like Mattanchery,
            Fort Kochi, etc.). Like tier-1 cities, there is an upraise of
            co-working spaces in tier-2 cities like Kochi. The Co-working spaces
            are rapidly growing and gaining acceptance in the city with
            increased occupancy rate.
            <br />
            <br />
            Being one of the business capitals of our country, Kochi is
            attracting big enterprises and SMEs towards co-working spaces
            whether you are a small start-up, a freelancer, or a major
            enterprise.
            <br />
            <br />
            The shipping, trade, Oil, Retail industry is big in the region. IT
            giants and ITes companies are setting up their hubs in Kochi. There
            are 4 SEZs built in the city. <br />
            <br />
            Freelancers and remote workers are huge in Kochi, especially those
            who have moved out from the major cities around Kochi and settled
            with WFA opportunities. Kochi has some of the best and eco-friendly
            co-working spaces suitable for users from all domains. The right
            environment ensures seamless productivity for its customers and
            provides additional amenities like a recreational zone.
            <br />
            <br />
            Some spaces integrate both co-working and co-living spaces as per
            the customers’ comfort. Many have cafeterias and food courts that
            satisfy taste buds, and some even offer a VR gaming experience to
            rejuvenate your mind. To conduct additional talks/discussions, they
            have provided a muse area to facilitate such activities.
            <br />
            <br />
          </p>
        </div>
      )
    case "Madurai":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>Enticing coworking in Madurai</h2>
          <p>
            Madurai is one of the oldest cities in India, deep-rooted in
            tradition, culture, and rich heritage of Southern India. The city
            has many archaeological wonders and historical monuments making it
            one of the most prominent cities in Tamilnadu. Madurai is also an
            important industrial and educational hub in South Tamil Nadu.
            <br />
            <br />
            Madurai, the city is known for its agricultural wealth but has
            expanded to become one of the most important industrial towns in
            Southern India. The city is home to many industrial and
            manufacturing units leading to one of the largest small-scale
            industries, and two IT SEZ. Name the companies, it will have a
            satellite office in Madurai. HCL, Honeywell, Robert Bosch, BHEL.
            Local start-up communities such as MaduraiStartup, Start-up
            Grind-Madurai Chapter, Meetup groups are quite active in guiding the
            entrepreneurs, SaaS companies and start-ups from the region. From
            cryptocurrency to gaming the city has grown in its native
            entrepreneurs making a global mark.
            <br />
            <br />
            Churning out some of the best talents from the region are some of
            the oldest educational institutions in India such as Madurai Medical
            College, Madurai Law College centuries old American College, Lady
            Doak, Fatima College, Madura College, Homeopathic Medical College,
            Agricultural College and Research Institute, Madurai Kamaraj
            University.
            <br />
            <br />
            The concept of coworking which began in the metro cities has now
            spawned the smaller cities and towns of India. Coworking spaces in
            Madurai offering hot desks and private cabins are gaining popularity
            as a brilliant solution for those who need office spaces on-demand
            with micro & short-term commitments. Coworking spaces are the future
            of work and even the small and medium scale business in rural and
            towns will see the value it brings.
            <br />
            <br />
            Organisations are still contemplating their workplace strategy and
            the ideal real estate setting. While monthly office and shared
            office are an enormous advantage in the Tier 1 markets, Tier 2 & 3
            cities are seeing greater run for on-demand spaces that offer much
            flexibility, affordability and are just a click away in their
            neighbourhood. Accelerated by the pandemic, we have shifted gears
            away from the long-term rental commercial spaces. City centric today
            are today experimenting with Work from Home or Work from Anywhere
            opportunities. Madurai, Kovai, Trichy et all seem to be the best
            alternatives.
            <br />
            <br />
            Seeing the Tier 1 cities bubble burst due to lack of infrastructure
            and the empowerment that remote work has given to inhabit the
            countryside, remote workforces are exploring settling in locations
            such as Madurai, where the cost of living is 40% lesser than Chennai
            or Bangalore. Workforces are over the urban frenzies. They are now
            looking to move in locations that are distributed, less populous and
            safer with fresher air and vibrant communities.
            <br />
            <br />
          </p>
        </div>
      )
    case "Trichy":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>Top coworking Space in Trichy</h2>{" "}
          <p>
            <br />
            <b>The charm of Tiruchirapalli</b>
            <br />
            <br />
            Trichy is primarily known as the temple town and cultural hub of
            Tamilnadu. Trichy has been home to some of the brightest minds
            including Sir C.V. Raman, Indian physicist, Andy Pulney, first
            Indian recipient of a British medical degree and infinite alumnus
            from the finest universities including NIT Trichy, Bharathidasan
            University, 100-year-old National College.
            <br />
            <br />
            Over the years, Trichy has experienced a surge in commercial and
            start-up growth.
            <br />
            <br />
            The city perfectly blends contemporary and cultural attributes,
            making it a perfect fit for remote workers and businesses to thrive.
            Since the exodus of city-living to regional locations, the remote
            hubs and satellite offices have increased the capability of Trichy
            being one of the most important Tier 2 markets.
            <br />
            <br />
            Trichy has seen an increase in the demand for office spaces in
            recent years. Especially since the movement of remote working, the
            on-demand workspaces have been surging. The traditional businesses
            and conventional entrepreneurs are still hesitant to take the move
            ahead, but with Gen Z and GenY experiencing productive and greater
            work-life balance, Trichy is the next hot spot.
            <br />
            <br />
            If you want to be close to where the action is happening in Trichy,
            Thillai Nagar is the place to be in. Well-built, greater
            infrastructure, it is the heart of commercial activities in Trichy.
            <br />
            <br />
            Packed with government and industrial establishments, banks, and
            other connectivity, Thillai Nagar is the location to be in.
            <br />
            <br />
            Between this hustle, fret not, GoFloaters brings to you coworking
            on-demand with one of the most premium yet affordable properties
            with hot desks in the city.
            <br />
            <br />
            From remote workers looking for a day pass or independent
            professionals looking to take virtual consulting to teachers looking
            for short term deals to take classes, coworking in Trichy has been a
            popular choice.
            <br />
            <br />
          </p>
        </div>
      )
    case "Visakhapatnam":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Best of Meeting Room in Vishakpatnam
          </h2>{" "}
          <p>
            Visakhapatnam or Vizag is the executive and industrial capital of
            Andhra Pradesh.
            <br />
            <br />
            The city is filled with bountifulness and natural beauty. Vizag is
            the most important hub for Indian maritime, Indian naval defence,
            India shipping, sea trade, and manufacturing sector. The city has an
            outlook of ambitious growth and happy liveability.
            <br />
            <br />
            Vizag is among the 100 smart cities to be developed in India. The
            new township is developing itself as one of the most well-planned
            cities in India. In its first industrial township, 100+ companies
            are operational including small to large-scale industries, power
            plants including HSL, RINL, small to large fisheries, sea trading
            and shipping entities. In addition, would be the software giants, IT
            and ITes companies, Fintech, and other tech start-ups. These
            industries and companies contribute to 80-90% of the GDP of the
            state.
            <br />
            <br />
            The city has grabbed the attention of international investors and
            particularly the Telugu NRIs who always wanted to have a
            world-class, overseas-like infrastructure in India. In this process,
            the city of Vizag has been receptive to welcoming the alternative
            model of work culture as a part of its decision for a better future.
            <br />
            <br />
            The remote work and hybrid work culture have offered business
            owners, remote workforces, and entrepreneurs of various industries a
            wide collaboration.
            <br />
            <br />
            Coworking and shared workspaces have been sprouting exponentially in
            Vizag. Each of the spaces offers a unique work environment emitting
            professionalism and productivity.
            <br />
            <br />
            Hot Desks, Private Cabins, Virtual offices enable businesses to
            create satellite and remote hubs. Because of the populous nature of
            industries & businesses, on-demand flexible workspaces for
            distributed remote teams are driving the market across Vizag.
            <br />
            <br />
          </p>
        </div>
      )
    case "Gaziabad":
      return (
        <div className="col-md-12">
          <br />
          <h2 style={{ fontWeight: "bold" }}>
            Coworking Space in Ghaziabad
          </h2>{" "}
          <p>
            The fastest growing city in the National Capital Region, Ghaziabad
            is a hub for manufacturing in North India. Situated Northeast of New
            Delhi, in Uttar Pradesh, Ghaziabad is 3rd most populated city in the
            state with 23 lakh people.
            <br />
            <br />
            While Ghaziabad is an old city, its industrial growth began late, in
            1940. The city's railways were built in the 1860s, but it wasn’t
            until 1940 that the value of the city was recognised and many
            national companies moved their manufacturing plants here.
            <br />
            <br />
            The first companies to make these moves were Mohan Nagar Industrial
            Estate and Tata Oil Mills in 1949. This began an influx of other
            manufacturing giants such as the Indian Tobacco Company and Shri Ram
            Pistons. The city has been an excellent location for manufacturing,
            owing to its connectivity to other cities, both for product delivery
            and to source raw materials.
            <br />
            <br />
            In the last few decades, the city has seen steady growth in its
            population. This has been accompanied by planned development,
            including new schools and colleges, better roads and a variety of
            amenities to support a great lifestyle. Numerous companies have also
            moved to the city during this time.
            <br />
            <br />
            The city has been showing great growth potential and remote work
            opportunities are just one among its various offerings. Coworking
            spaces are a great option for entrepreneurs, freelancers and
            employers. Some of the key benefits of Coworking spaces for
            employers are:
            <br />
            <br />
            <ul>
              <li>Flexibility and cost-effectiveness</li>
              <li>
                Employers need not spend on setting up offices and office
                management costs.
              </li>
              <li>An increase in opportunities</li>
              <li>
                Presents the opportunity to find talent from anywhere in the
                world and not restricted by geographic boundaries.
              </li>
              <li>Hub of talents</li>
              <li>
                Working in co-working spaces allows you to meet and interact
                with people from different sectors and encourage ideas and fresh
                thinking.
              </li>
              <li>Increased focus</li>
              <li>
                A dedicated workspace results in better work, and co-working
                spaces provide dedicated works spaces for when you need it.
              </li>
              <li>A work-life balance</li>
              <li>
                The ability to manage your work and life on your own terms can
                improve overall happiness.
              </li>
            </ul>
            <br />
          </p>
        </div>
      )
    case "Coimbatore":
      return (
        <div className="col-md-12">
          <br />
          <h2 style={{ fontWeight: "bold" }}>
            Affordable coworking space in Coimbatore
          </h2>{" "}
          <p>
            <b>The City of Coimbatore</b>
            <br />
            Coimbatore is a dynamic city, booming on textile, small and medium
            manufacturing and automotive hub and agriculture related centres.
            The city is surrounded by hill stations and many other suburbs and
            towns which are famous for natural reserves, products and mainly the
            textiles industry. <br />
            <br />
            The city is home to 200+ institutions prestigious universities of
            engineering and medical including PSG College of Technology, Amrita
            Vishwa Vidyapeetham, Karunya Institute of Technology and Science,
            Kumaraguru College of Technology, Sri Ramakrishna Engineering
            College, Hindusthan College of Engineering, and technology. From the
            early stages of education in the universities, the students are
            introduced and imbibed into a culture of entrepreneurship and
            innovations in each of these institutions. There are many
            enterprises, businesses, freelancers, game changing start-ups
            including bio and rural innovations. <br />
            <br />
            IT, ITes, SaaS companies and tech innovations centres have taken
            special affiliation to the city as it is one of the second most
            important and role model cities in Tamilnadu. Companies such as
            Zoho, Kovai.co, Cognizant, Sutherland, Pricol and many more have
            their hubs in the city.
            <br />
            <br />
            <b>Coworking Space in Coimbatore</b>
            <br />
            The city has grown to adapt to coworking as a culture. Remote
            workforces and who are working remotely are discovering and booking
            top on-demand office centres around their neighbourhood, staying
            productive and distraction free.
            <br />
            <br />
            All you must do is log on to GoFloaters.com or download the app,
            find the closest flexible coworking space near you, book, get your
            laptop, and dive into work. Each coworking space is loaded with the
            best and ideal amenities. In addition would be the access network of
            collaborators, associates, agencies, investors, mentors and more.
            Before you go further, don’t forget to read our definitive guide to
            Coworking Space in Coimbatore.
            <br />
            <br />
          </p>
        </div>
      )
    case "Chennai":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Looking for coworking spaces in Chennai?
          </h2>
          <p>
            Coworking spaces in Chennai offer a dynamic and modern environment
            for professionals. They are well-equipped with state-of-the-art
            cabins, conference rooms, and open spaces for collaboration or quick
            meetings. These spaces are highly valued for their friendly and
            cooperative atmosphere, which fosters interaction and networking
            among different businesses and professionals.{" "}
          </p>
          <p>
            Most coworking spaces in Chennai provide complete office amenities,
            high-quality office space, and are conveniently located. They cater
            to diverse needs, offering a range of services from high-speed WiFi,
            power backup, AC, parking, and even in-house cafes with food
            options. These spaces are praised for their beautiful decor,
            ambiance, and well-maintained facilities, making them ideal for
            focused work, meetings, and events.{" "}
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Average Day Pass Cost in Chennai
          </h3>
          <p>
            The average cost for a day pass in Chennai's coworking spaces, as
            offered by GoFloaters, starts at ₹149. This all-inclusive pricing
            model makes it an affordable option for professionals seeking a
            temporary workspace
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Best Locations for Coworking Spaces in Chennai
          </h3>
          <p>
            1.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=T%20Nagar">
              Coworking Spaces in T. Nagar
            </a>
            <br />
            T. Nagar, known for its bustling shopping and commercial activities,
            is a prime spot for coworking spaces in Chennai. These spaces are
            popular among professionals seeking a vibrant work environment,
            offering state-of-the-art amenities and easy access to retail hubs,
            dining options, and transport facilities. It's an ideal location for
            entrepreneurs and businesses desiring a blend of traditional charm
            and modern convenience.
          </p>
          <p>
            2.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=Perungudi">
              Coworking Spaces in Perungudi
            </a>
            <br />
            Perungudi is Chennai&rsquo;s IT corridor, home to tech parks and
            numerous IT companies. Coworking spaces here are tailored for tech
            startups and professionals, featuring high-tech infrastructure and a
            collaborative environment. The area attracts a mix of tech
            entrepreneurs, developers, and IT consultants, fostering a community
            of innovation and technological advancement.
          </p>
          <p>
            3.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=Nungambakkam">
              Coworking Spaces in Nungambakkam
            </a>
            <br />
            Nungambakkam is a central location in Chennai, known for its diverse
            business landscape and cultural richness. Coworking spaces in this
            area offer a prestigious address, surrounded by corporate offices,
            consulates, and educational institutions. They provide a perfect mix
            of professionalism and cultural engagement, making them attractive
            for a wide range of professionals.
          </p>
          <p>
            4.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=Anna%20Nagar">
              Coworking Spaces in Anna Nagar
            </a>
            <br />
            Anna Nagar, with its planned layout and abundant amenities, offers a
            serene and organized coworking environment. The spaces here cater to
            freelancers, small teams, and startups, combining modern facilities
            with a peaceful setting. It&rsquo;s a great choice for those seeking
            a balanced work-life environment in a well-developed area.
          </p>
          <p>
            5.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=Guindy">
              Coworking Spaces in Guindy
            </a>
            <br />
            Situated near the industrial and IT hubs, coworking spaces in Guindy
            are ideal for businesses and professionals in manufacturing,
            engineering, and IT sectors. These spaces benefit from excellent
            connectivity to the city and the airport, making them a strategic
            location for businesses with a global outlook.
          </p>
          <p>
            6.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=Thoraipakkam">
              Coworking Spaces in Thoraipakkam
            </a>
            <br />
            Thoraipakkam&rsquo;s central location makes it a unique spot for
            coworking. The coworking spaces here blend heritage charm with
            contemporary facilities, attracting a mix of creative professionals,
            writers, and entrepreneurs who appreciate a workspace with character
            and convenience.
          </p>
          <p>
            7.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=Nandanam">
              Coworking Spaces in Nandanam
            </a>
            <br />
            Nandanam, a posh residential and commercial area, offers upscale
            coworking spaces that are preferred by high-profile businesses and
            professionals. These spaces provide luxury amenities and exclusive
            networking opportunities in a sophisticated environment.
          </p>
          <p>
            8.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=Neelankarai">
              Coworking Spaces in Neelankarai
            </a>
            <br />
            Neelankarai, known for its serene coastal beauty and upscale
            neighborhoods, offers a tranquil and inspiring environment for
            coworking spaces. Ideal for businesses and professionals who seek a
            peaceful yet dynamic work setting, these spaces often feature
            panoramic sea views and a relaxed ambiance. The area appeals to
            creative professionals, entrepreneurs, and those who value a blend
            of work-life balance in a scenic coastal setting. Its proximity to
            the beach and residential areas makes it a unique and desirable
            location for a harmonious and productive working experience.
          </p>
          <p>
            9.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=Kilpauk">
              Coworking Spaces in Kilpauk
            </a>
            <br />
            Kilpauk, with its green spaces and calm ambiance, is perfect for
            those seeking a tranquil coworking environment. The coworking spaces
            here cater to creative minds and wellness-focused professionals,
            providing a harmonious work setting close to nature and the beach.
          </p>
          <p>
            10.{" "}
            <a href="https://gofloaters.com/coworking-spaces/chennai/all?locality=Mylapore">
              Coworking Spaces in Mylapore
            </a>
            <br />
            Mylapore, blending rich cultural heritage with urban lifestyle,
            offers coworking spaces that are both inspiring and convenient.
            Ideal for artists, designers, and cultural entrepreneurs, these
            spaces are set amidst historical landmarks, offering a unique blend
            of tradition and modernity.
          </p>
          <p>
            Each of these locations in Chennai offers distinct advantages,
            catering to the diverse needs of the city&rsquo;s professional
            community, from tech giants to creative freelancers.
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Why Book Coworking Spaces in Chennai on GoFloaters?
          </h3>
          <p>
            Booking coworking spaces in Chennai through GoFloaters offers
            several advantages. The platform has been helping individuals and
            teams find flexible and affordable workspaces for over three years.
            GoFloaters provides the convenience of finding office spaces close
            to home, with most spaces located within 5 km of the user's
            location.{" "}
          </p>
          <p>
            Their pay-per-use model allows for daily bookings of coworking
            spaces and hourly bookings for meeting spaces, ensuring users pay
            only for the time they use. Additionally, GoFloaters offers
            cost-effective options without requiring any contracts, along with
            instant booking features. They also provide community perks by
            partnering with over 65 companies, offering substantial benefits to
            users.{" "}
          </p>
        </div>
      )
    case "Hyderabad":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>Coworking Spaces in Hyderabad</h2>
          <p>
            Coworking spaces in Hyderabad provide professionals with modern,
            collaborative work environments. These spaces are equipped with
            cutting-edge amenities, including comfortable workstations, meeting
            rooms, and community areas. Hyderabad's coworking scene is known for
            its tech-savvy atmosphere, attracting startups and entrepreneurs.
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Average Day Pass Cost in Hyderabad
          </h3>
          <p>
            The average day pass cost for coworking spaces in Hyderabad varies
            but typically starts at ₹200, making it a cost-effective choice for
            individuals seeking temporary workspaces.{" "}
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Best Locations for Coworking Spaces in Hyderabad
          </h3>
          <p>
            1.
            <a href="https://gofloaters.com/coworking-spaces/hyderabad/all?locality=HITEC%20City">
              Coworking Spaces in HITEC City
            </a>{" "}
            <br />
            As Hyderabad's premier IT and business hub, HITEC City is a prime
            location for coworking spaces. These spaces are equipped with
            top-tier amenities and offer networking opportunities with tech
            giants and startups. The area's bustling atmosphere, coupled with
            its proximity to major tech parks and corporate offices, makes it a
            sought-after spot for businesses seeking technological excellence
            and connectivity.{" "}
          </p>
          <p>
            2.
            <a href="https://gofloaters.com/coworking-spaces/hyderabad/all?locality=Gachibowli">
              Coworking Spaces in Gachibowli
            </a>{" "}
            <br />
            Gachibowli, known for its concentration of IT companies and
            start-ups, is another hub for coworking in Hyderabad. The coworking
            spaces here are characterized by their modern design and focus on
            community and collaboration, making it an ideal location for
            innovative minds and entrepreneurs.{" "}
          </p>
          <p>
            3.
            <a href="https://gofloaters.com/coworking-spaces/hyderabad/all?locality=Madhapur">
              Coworking Spaces in Madhapur
            </a>{" "}
            <br />
            Madhapur, adjacent to HITEC City, is also a key location for
            coworking, blending modernity and accessibility. Coworking spaces in
            this area attract a diverse mix of professionals, offering dynamic
            and collaborative environments. Its strategic location and rich
            array of dining and leisure options make it a popular coworking
            destination.{" "}
          </p>
          <p>
            4.Coworking Spaces in Jubilee Hills
            <br />
            Jubilee Hills, a posh residential and commercial area, hosts
            coworking spaces that are preferred by creative professionals and
            high-growth startups. These spaces offer sophisticated technology,
            upscale amenities, and a networking-rich environment, making it an
            ideal location for those seeking luxury in a coworking space.
          </p>
          <p>
            5.
            <a href="https://gofloaters.com/coworking-spaces/hyderabad/all?locality=Banjara%20Hills">
              Coworking Spaces in Banjara Hills
            </a>
            Banjara Hills is known for its upscale ambience and is increasingly
            becoming popular for coworking spaces. These spaces provide a blend
            of luxury and functionality, catering to well-established businesses
            and upscale professionals seeking premium coworking experiences.{" "}
          </p>
          <p>
            6.
            <a href="https://gofloaters.com/coworking-spaces/hyderabad/all?locality=Kondapur">
              Coworking Spaces in Kondapur
            </a>{" "}
            <br />
            Kondapur, located near HITEC City, is emerging as a coworking hub,
            known for its affordable office spaces and proximity to the IT
            district. The coworking spaces here offer flexible arrangements and
            are ideal for small startups and independent professionals.{" "}
          </p>
          <p>
            7.
            <a href="https://gofloaters.com/coworking-spaces/hyderabad/all?locality=Begumpet">
              Coworking Spaces in Begumpet
            </a>{" "}
            <br />
            Situated in central Hyderabad, Begumpet is a strategic location for
            coworking due to its excellent connectivity and mix of residential
            and commercial setups. The coworking spaces here cater to a diverse
            professional crowd, offering convenient and efficient working
            environments.
          </p>
          <p>
            8.
            <a href="https://gofloaters.com/coworking-spaces/hyderabad/all?locality=Kukatpally">
              Coworking Spaces in Kukatpally
            </a>{" "}
            <br />
            Kukatpally, a major residential and commercial suburb, is emerging
            as a favored location for coworking spaces in Hyderabad. These
            spaces are particularly appealing to startups and small to
            medium-sized businesses due to their affordability and robust
            infrastructure. The area's blend of commercial activity and
            residential comfort, along with its accessibility to the IT hubs,
            makes it an attractive choice for a wide range of professionals.
          </p>
          <p>
            9.
            <a href="https://gofloaters.com/coworking-spaces/hyderabad/all?locality=Film%20Nagar">
              Coworking Spaces in Film Nagar
            </a>{" "}
            <br />
            Film Nagar, known for its connection to the Telugu film industry,
            offers coworking spaces that are uniquely suited for creatives in
            media, film, and entertainment. These spaces foster a vibrant
            community of artists, filmmakers, and entrepreneurs, providing an
            inspiring and collaborative environment. The area&rsquo;s scenic
            beauty and proximity to major production studios add to its charm,
            making it a sought-after coworking destination for those in the
            creative industries.
          </p>
          <p>
            10.Coworking Spaces in Uppal
            <br />
            Uppal, an industrial and tech hub in East Hyderabad, is gaining
            traction for its coworking spaces. These are ideal for tech startups
            and manufacturing companies looking for spacious, cost-effective
            coworking solutions in a rapidly developing area. <br />
            Each of these locations in Hyderabad offers unique benefits, serving
            the varied preferences and needs of the city's diverse professional
            community. From bustling IT hubs to upscale neighborhoods,
            Hyderabad's coworking scene caters to a wide spectrum of business
            needs and styles.{" "}
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Why Book Coworking Spaces in Hyderabad on GoFloaters?
          </h3>
          <p>
            {" "}
            Booking coworking spaces in Hyderabad on GoFloaters is beneficial
            due to its extensive network of workspaces in prime locations. Users
            can enjoy the convenience of flexible bookings and access to a
            vibrant community of professionals, fostering networking and
            business opportunities.
          </p>
        </div>
      )
    case "Mumbai":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Inspiring coworking space in Mumbai
          </h2>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Coworking Spaces in Mumbai
          </h3>
          <p>
            Coworking spaces in Mumbai provide flexible and modern work
            environments for professionals and businesses. These spaces are
            equipped with state-of-the-art facilities, including well-designed
            workstations, meeting rooms, and amenities like high-speed internet,
            power backup, and more. They are strategically located across the
            city, making them easily accessible to individuals and teams.
            Coworking spaces in Mumbai are known for fostering collaboration and
            networking among diverse professionals.
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Average Day Pass Cost in Mumbai
          </h3>
          <p>
            The average day pass cost for coworking spaces in Mumbai varies
            depending on the location and facilities provided. It typically
            starts at ₹325, making it an affordable option for those seeking
            temporary workspace solutions.{" "}
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Best Locations for Coworking Spaces in Mumbai
          </h3>
          <p>
            <strong>Coworking Spaces in Bandra Kurla Complex (BKC)</strong>
            The premier commercial hub of Mumbai, BKC houses luxurious coworking
            spaces ideal for businesses seeking a prestigious address. Known for
            high-end amenities and networking opportunities with top
            professionals, BKC stands as the epitome of modern corporate culture
            in Mumbai.
            <a href="https://gofloaters.com/coworking-spaces/mumbai/all?locality=Powai">
              Coworking Spaces in Powai
            </a>{" "}
            <br />
            Famed for its vibrant startup culture and scenic lakeside setting,
            Powai's coworking spaces cater to young entrepreneurs and creatives.
            These spaces are known for their innovative design and
            community-centric environment, perfect for fostering collaboration
            and ideation.
          </p>
          <p>
            <a href="https://gofloaters.com/coworking-spaces/mumbai/all?locality=Lower%20Parel">
              Coworking Spaces in Lower Parel
            </a>
            <br />
            Blending industrial heritage with modern development, Lower Parel
            offers a unique coworking experience with a mix of traditional charm
            and contemporary facilities. Its central location and lifestyle
            amenities make it a favorite among diverse professionals.
          </p>
          <p>
            <a href="https://gofloaters.com/coworking-spaces/mumbai/all?locality=Andheri%20East">
              Coworking Spaces in Andheri East
            </a>
            <br /> A bustling IT and commercial zone, Andheri East features
            state-of-the-art coworking spaces ideal for tech startups and
            digital professionals. These spaces provide the latest technology
            and collaborative environments in the city's dynamic area.
          </p>
          <p>
            Coworking Spaces in Goregaon
            <br />
            Known for its commercial zones and green spaces, Goregaon is
            emerging as a popular coworking hub. It offers affordable and
            vibrant workspaces with flexible options and incubation support,
            appealing to startups and entrepreneurs.
          </p>
          <p>
            <strong>Coworking Spaces in Nariman Point</strong> <br />
            As Mumbai's original business district, Nariman Point offers
            prestigious coworking spaces with sea views, favored by high-profile
            businesses. These spaces provide premium amenities in a location
            known for corporate success.
          </p>
          <p>
            <a href="https://gofloaters.com/coworking-spaces/mumbai/all?locality=Vikhroli%20West">
              Coworking Spaces in Vikhroli West
            </a>
            <br />
            Bridging South Mumbai and the suburbs, Vikhroli West is known for
            its upscale coworking spaces that balance accessibility with luxury.
            The scenic seaface and modern amenities make it an attractive
            coworking destination.
          </p>
          <p>
            <a href="https://gofloaters.com/coworking-spaces/mumbai/all?locality=Vashi">
              Coworking Spaces in Vashi
            </a>
            <br />
            Located in Navi Mumbai, Vashi offers a relaxed coworking environment
            with spacious and affordable spaces. It's suitable for businesses
            that prefer a peaceful atmosphere and cost-effective solutions.{" "}
          </p>
          <p>
            <a href="https://gofloaters.com/coworking-spaces/mumbai/all?locality=Thane">
              Coworking Spaces in Thane
            </a>
            <br />
            Thane is rapidly growing as a coworking hub, attracting businesses
            with its blend of urban and natural landscapes. The coworking spaces
            here offer a mix of affordability and quality, making it an ideal
            choice for startups and small businesses seeking growth in a
            thriving community.{" "}
          </p>
          <p>
            <a href="https://gofloaters.com/coworking-spaces/mumbai/all?locality=Nerul">
              Coworking Spaces in Nerul
            </a>
            <br />
            Nerul, in Navi Mumbai, is becoming popular for its modern coworking
            spaces that cater to a diverse professional crowd. With its
            excellent connectivity to Mumbai and affordable options, Nerul is an
            emerging hotspot for new-age entrepreneurs and established
            businesses alike. <br />
            Each of these locations in Mumbai provides unique advantages,
            serving the varied preferences and requirements of the city's
            diverse professional community. From luxurious corporate
            environments to creative and emerging hubs, Mumbai's coworking scene
            reflects the city's dynamic and varied character.{" "}
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Why Book Coworking Spaces in Mumbai on GoFloaters?
          </h3>
          <p>
            Booking coworking spaces in Mumbai on GoFloaters offers several
            advantages. The platform provides a hassle-free way to find
            workspaces in convenient locations across the city. Users can book
            spaces on a pay-per-use basis, allowing flexibility in terms of time
            and budget. GoFloaters also partners with various companies,
            offering community perks and benefits to its users, making it a
            cost-effective and convenient choice for professionals and
            businesses
          </p>
        </div>
      )
    case "Pune":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Booking on-demand Coworking Space in Pune
          </h2>
          <p>
            Pune is the 2nd largest metro city in Maharashtra, an extension of
            Mumbai. Pune is also the most populous city and still the most
            liveable city in India. Pune is one of the most important hubs for
            education, automotive, manufacturing in India. The most recognised
            brands in the IT and ITes have their satellite offices in the city
            in the Infotech parks around the city. Pune is home to numerous
            governmental and non-governmental research institutes in the areas
            of science, defence and advanced technology. Besides, Pune is also
            known to host India's most important MICE and networking business
            events.
            <br />
            <br />
            Pune has the largest number of educational institutions. Every year
            it attracts many international and national students.
            <br />
            <br />
            All businesses, start-ups and large organisations are experimenting
            and re-inventing their work models. CHROs are coming up with various
            strategies with customers in the main. Companies are emphasis on
            mental and physical wellbeing of the employees and teams and
            exploring #officeless models. Pune is home to 3+ Unicorns including
            Icertis- SaaS-based Indian Unicorn, Druva- ride hailing company and
            FirstCry - e-commerce giant.
            <br />
            <br />
            Stay-at-home freelancers and independent professionals are stalking
            opportunities to explore out-of-home work focussed hours.
            <br />
            <br />
            From looking for Hot Desk, private cabins to short & long-term{" "}
            <a href="https://gofloaters.com/office-spaces/pune/">
              offices space in Pune
            </a>
            , at GoFloaters you will have a variety of options to choose from in
            your favoured location with ample amenities suiting every business
            and team need. From single desks to{" "}
            <a href="https://gofloaters.com/meeting-spaces/pune/all">
              meeting rooms
            </a>{" "}
            to fully furnished offices, the demand is exceeded. And as experts,
            GoFloaters is happy to serve the best.
            <br />
            <br />
          </p>
        </div>
      )
    case "New Delhi":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>Coworking Spaces in New Delhi</h2>
          <p>
            Coworking spaces in New Delhi offer a diverse range of work
            environments, from bustling urban centers to tranquil suburban
            locations. These spaces cater to professionals seeking flexibility,
            with a variety of amenities, including high-speed internet, meeting
            rooms, and vibrant communities that foster networking and
            collaboration.{" "}
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Average Day Pass Cost in New Delhi
          </h3>
          <p>
            The average day pass cost for coworking spaces in New Delhi starts
            at ₹249, making it an affordable choice for those in need of
            temporary workspaces in the capital city.{" "}
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Best Locations for Coworking Spaces in New Delhi
          </h3>
          <p>
            1.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=Connaught%20Place">
              Coworking Spaces in Connaught Place
            </a>
            <br />
            As the central business district of New Delhi, Connaught Place is a
            highly sought-after area for coworking spaces. Offering upscale
            amenities and networking opportunities with top-tier professionals,
            its lively environment and close proximity to important commercial
            and government establishments make it ideal for businesses seeking a
            prestigious and well-connected location.{" "}
          </p>
          <p>
            2.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=Dwarka">
              Coworking Spaces in Dwarka
            </a>
            <br />
            Dwarka, known for its well-planned layout and modern infrastructure,
            is becoming a popular choice for coworking spaces. These spaces are
            favored by a range of professionals and startups, offering a blend
            of affordability and accessibility, coupled with the tranquility of
            a residential area.{" "}
          </p>
          <p>
            3.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=Mohan%20Estate">
              Coworking Spaces in Mohan Estate
            </a>
            <br />
            Situated in South Delhi, Mohan Estate is an emerging commercial hub
            offering modern coworking spaces. The area is known for its spacious
            office setups and industrial presence, making it suitable for both
            manufacturing and service-oriented businesses seeking a strategic
            location in the city.{" "}
          </p>
          <p>
            4.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=Pitam%20Pura">
              Coworking Spaces in Pitampura
            </a>
            <br />
            Pitampura, a residential and commercial district in North Delhi,
            offers coworking spaces that blend comfort with professionalism.
            These spaces are ideal for startups and individual entrepreneurs who
            seek a quiet yet resourceful working environment in a
            well-established area.{" "}
          </p>
          <p>
            5.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=Paschim%20Vihar">
              Coworking Spaces in Paschim Vihar
            </a>
            <br />
            Paschim Vihar, predominantly a residential area, is developing into
            a coworking hub with spaces that offer a peaceful work environment
            away from the city's hustle. These spaces are ideal for freelancers
            and small teams looking for affordable and serene working
            conditions.{" "}
          </p>
          <p>
            6.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=Vasant%20Kunj">
              Coworking Spaces in Vasant Kunj
            </a>
            <br />
            Vasant Kunj, an affluent locality, is home to high-end coworking
            spaces. These are preferred by businesses and professionals who seek
            luxury workspaces in a serene environment, with the added benefit of
            being close to premium residential areas and lifestyle amenities.{" "}
          </p>
          <p>
            7.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=Vasant%20Vihar">
              Coworking Spaces in Vasant Vihar
            </a>
            <br />
            Vasant Vihar, known for its upscale residential neighborhoods,
            offers coworking spaces that provide a perfect balance of luxury and
            tranquility. These spaces cater to high-profile entrepreneurs and
            professionals looking for exclusive amenities in one of
            Delhi&rsquo;s most prestigious areas.{" "}
          </p>
          <p>
            8.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=Okhla%20Industrial%20Area">
              Coworking Spaces in Okhla
            </a>
            <br />
            An industrial and business district, Okhla hosts spacious, modern
            coworking spaces suitable for various businesses. Its ongoing
            development, proximity to educational institutions and business
            centers make it a strategic choice for companies seeking growth and
            scalability.{" "}
          </p>
          <p>
            9.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=East%20of%20Kailash">
              Coworking Spaces in East of Kailash
            </a>
            <br />
            With its tranquil environment and excellent connectivity, East of
            Kailash is a preferred location for coworking spaces. Combining
            suburban peace with urban accessibility, it&rsquo;s an attractive
            spot for professionals who value a productive and inspiring work
            setting.{" "}
          </p>
          <p>
            10.
            <a href="https://gofloaters.com/coworking-spaces/new-delhi/all?locality=Nehru%20Place">
              Coworking Spaces in Nehru Place
            </a>
            <br />
            As a major IT market, Nehru Place&rsquo;s coworking spaces primarily
            serve tech companies and professionals. These spaces offer robust IT
            infrastructure and tech support, making it an ideal environment for
            tech startups and IT consultants. <br />
            Each location in New Delhi provides unique benefits, catering to the
            diverse needs of the city's professional community, from bustling
            commercial hubs to serene residential areas. This diversity in
            coworking spaces reflects New Delhi&rsquo;s multifaceted character.{" "}
          </p>
          <h3 style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            Why Book Coworking Spaces in New Delhi on GoFloaters?
          </h3>
          <p>
            Booking coworking spaces in New Delhi on GoFloaters is advantageous
            due to the platform's wide network of spaces across the city. It
            provides users with cost-effective, on-demand access to workspaces
            in prime locations, ensuring convenience and flexibility for
            professionals and businesses.{" "}
          </p>
        </div>
      )
    case "Indore":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Motivating Coworking Space in Indore
          </h2>
          <p>
            Indore is located in the state of Madhya Pradesh. It was founded in
            1715 as a trade market on the Narmada Valley route by a landlord.
            The name of the city is derived from the historic Indreshwar temple.
            <br />
            <br />
            <b>Focused on Growth</b>
            <br />
            An old city, today Indore is home to renowned academic institutions
            including IIM, IIT, Devi Ahilya Bai University, Academic Center for
            advanced technology, among others. This is reflected in the literacy
            rate of Indore is 87.38%, which is higher than the national average
            of 74%. The female literacy rate of Indore is also around 83%, and
            the majority of workspaces have women working alongside men.
            <br />
            <br />
            Indore today continues to remain as a central commercial centre for
            receiving goods and services for the state of Madhya Pradesh, a
            result of planned development that the city’s administration has
            ensured. The support from the government, good connectivity with the
            rest of the country via different means of transportation,
            availability of capital, surplus employees for both formal and
            informal sectors have also encouraged industrial growth in the city.
            Today, companies such as Google, Tata Consultancy Services, Infosys,
            TaskUs, and Amazon have set up shop in the town.
            <br />
            <br />
            <b>New Opportunities</b>
            <br />
            The quickly modernising city now also presents remote working
            opportunities for its residents. Coworking offers an excellent way
            for people to run their businesses or change their routine. With
            several spaces to choose from, you can use{" "}
            <a href="https://gofloaters.com/blog/the-best-coworking-spaces-in-indore-hot-desk-and-meeting-rooms/">
              coworking spaces in indore
            </a>{" "}
            to work on your own, or even better, collaborate with teams.
            <br />
            <br />
            Options such as coworking provide numerous benefits, such as <br />
            <ul>
              <li>More networking opportunity</li>
              <li>Increased productivity</li>
              <li>Boost in Creativity</li>
              <li>Collaboration opportunities</li>
              <li>Cost-efficiency</li>
            </ul>
            If you’re looking to change the way you work, find the co-working
            space that works for you, right here on GoFloaters.com or through
            our mobile app!
            <br />
            <br />
          </p>
        </div>
      )
    case "Kolkata":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Productive Coworking space in Kolkata
          </h2>
          <p>
            <b>The City of Joy</b>
            <br />
            Kolkata is India’s cultural gem on the eastern coast. Situated along
            the Bay of Bengal, this coastal city was once the Capital of India
            and now holds its own as the state capital of West Bengal.
            <br />
            <br />
            As the former capital of British India, Kolkata retains a feast of
            colonial-era architecture contrasting starkly with modern suburbs.
            The city is well known today for both its history and the great
            people that come from here, from early greats like Ravindranath
            Tagore to modern-day household names such as Saurabh Ganguly. <br />
            <br />
            <b>The Metropolis of the East</b>
            <br />
            Shaped over the last 330 years, has evolved significantly, but
            Kolkata continues to remain a hub of activity. The city serves as a
            connecting point with the northeast and is well known for its
            schools and universities that are nationally acclaimed. It is also
            home to a thriving economy with numerous MNCs setting up shop in the
            city, fueled with talent from the innumerable well-known
            universities located in and around the city.
            <br />
            <br />
            Today, many companies such as ITC Limited, CESC Limited, Exide
            Industries, Emami, Eveready Industries India, Lux Industries, Rupa
            Company, Berger Paints, Patton International Limited, Birla
            Corporation and Britannia Industries have set up offices in the city
            and fuel its population.
            <br />
            <br />
            Co-working spaces present an excellent option for people who need a
            space to work from to support the growing economy. GoFloaters offers
            open desks, meeting rooms and entire office spaces for rent. Easy to
            use and quick to sign up to, you can book your next desk or meeting
            room on the go! Check out all our offerings on the GoFloaters
            website or the mobile app today!
            <br />
            <br />
          </p>
        </div>
      )
    case "Noida":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Plug'n' Play Coworking Space in Noida
          </h2>
          <p>
            Looking for coworking spaces in Noida? Book the best coworking space
            with all the amenities in Noida. Choose from hot desks to private
            cabins, based on your team size.
            <br />
            <br />
            New Okhla Industrial Development Authority, in short, Noida is a
            satellite city of Delhi and a part of the NCR or National Capital
            Region of India. Its administrative headquarters is situated in
            Greater Noida. 50% of Noida is covered by trees and hence it is
            India’s greenest city. The Noida authority has a surplus of funds,
            so much so that it can run the city efficiently even if it does not
            collect any taxes from its taxpayers for 5 years in a row. This
            makes the Noida Authority one of the richest civic bodies in all of
            India. Noida comes under the Special Economic Zone (SEZ).
            <br />
            <br />
            Noida has become a popular spot for Information Technology
            industries as many of the IT companies have set up base here.
            Companies offering services in the fields of banking, pharma,
            financial services, auto, insurance, manufacturing and fast-moving
            goods call Noida their home. The past decade has seen Noida emerge
            as a hub for mobile and software companies. Companies like Samsung,
            HCL, Barclay’s, CSC and Agicent are major contributors to the city’s
            economy due to their software product development and service export
            dealing in foreign currency.
            <br />
            <br />
            Coworking spaces offer individuals and companies the flexibility of
            access to work spaces that have all the amenities of a traditional
            office and sometimes more on a simple rental model. The biggest
            advantage of coworking spaces is the networking opportunities.
            Coworking spaces on GoFloaters platform are available on day basis
            rentals where you just pay-per-use as per your need. You don’t sign
            any contracts or lock-in your money on security deposits.
            <br />
            <br />
            Some popular brands of coworking spaces in Noida are Regus, Awfis,
            ABL Workspaces, Workplace83, Let’s Connect Coworking and
            91Springboard.
            <br />
            <br />
          </p>
        </div>
      )
    case "Jaipur":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Step into Premium Coworking Spaces in Jaipur
          </h2>
          <p>
            Royal Heritage - Academic Excellence - Scenic Splendor - Historic
            Fortresses - Dynamic Social Landscape. Jaipur, the Pink City, exudes
            a charm that beautifully marries the past with the present, making
            it a hotspot for entrepreneurs and professionals alike.
            <br />
            <br />
            Jaipur's vibrant populace is a blend of traditional artisans,
            modern-day professionals, and students from its reputed educational
            institutes. As the capital city of Rajasthan, Jaipur is not just a
            tourist destination but has evolved as a hub for various industries,
            including handicrafts, gems and jewelry, and in recent times, IT and
            startups. While the city reverberates with tales of its majestic
            past, it's also opening chapters of modern-day corporate tales.
            <br />
            <br />
            The game-changer? Coworking! The last few years have witnessed a
            surge in coworking spaces in Jaipur, with hubs like ThinkSpace, The
            Springboard, and Jaipur CoWork gaining popularity. These spaces
            cater to the city's diverse professional community, offering not
            just workstations but an environment that fosters creativity and
            collaboration.
            <br />
            <br />
            It's not just about flexible desks; these coworking setups in Jaipur
            also boast of state-of-the-art meeting rooms and dedicated office
            spaces that can be rented on a monthly basis.
            <br />
            <br />
            Venture into the world of coworking opportunities that Jaipur has in
            store, exclusively at GoFloaters.com.
            <br />
            <br />
          </p>
        </div>
      )
    case "Gurugram":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            The Best Coworking Spaces in Gurugram
          </h2>
          <p>
            Gurugram, formerly Gurgaon, is a city in Haryana, which lies in the
            National Capital Region. Home to approximately 11,50,000 residents,
            it is located near the Indira Gandhi International Airport. It has
            easy access to southwest New Delhi, making it a great place to live
            and work and travel from.
            <br />
            <br />
            Gurugram is situated on National Highway 48 and provides easy
            connectivity to New Delhi in the north and Mumbai in the south via
            Jaipur and Ahmedabad. Aside from intercity connectivity, Gururgram
            provides excellent connectivity within the city through its metro
            rail network and the Delhi metro lines. <br />
            <br />
            <b>A tech oasis in NCR</b>
            <br />
            The city has quickly grown and developed around the multitude of
            companies that have set up offices here. It has numerous tech parks
            filled with amenities that keep bringing people back, even on
            weekends.
            <br />
            <br />
            As one of the top 5 information technology hubs and financial and
            banking hubs in the country, Gurugram sees many people migrating to
            the city searching for jobs. Gurgaon's economic growth started in
            the 1970s when Maruti Suzuki India Limited established a
            manufacturing plant and gathered pace after General Electric
            launched its business outsourcing operations in collaboration with
            real estate firms.
            <br />
            <br />
            Today, Gurugram is filled with enterprising individuals looking to
            make the most of life. Be it budding entrepreneurs, freelancers or
            techies with flexible work routines and remote work lifestyles.
            <br />
            <br />
            Co-working spaces offer an excellent opportunity to have the best of
            both worlds. If you’re from the city or passing through, GoFloaters
            provides various workspaces across Gurugram for you to choose from,
            and you can book it right here on our website or through the mobile
            app.
            <br />
            <br />
          </p>
          <h2 style={{ fontWeight: "bold" }}>
            Why Choose Coworking Spaces in Gurugram via GoFloaters?
          </h2>
          <p>
            Opting for coworking spaces in Gurugram through GoFloaters brings a
            multitude of benefits. The service presents an extensive array of
            coworking solutions throughout the city, tailored to meet diverse
            needs and financial considerations. The ease of navigating
            GoFloaters' interface streamlines the process of locating and
            securing the perfect space. Moreover, the platform guarantees clear
            and upfront pricing, often coupled with competitive fees and
            adaptable reservation terms.
            <br />
            <br /> GoFloaters ensures that clients in Gurugram have access to
            affordable yet high-quality spaces, equipped with all necessary
            amenities. This makes it an excellent option for both individual
            professionals and businesses seeking a conducive work environment in
            the city.
          </p>
        </div>
      )
    case "Faridabad":
      return (
        <div className="col-md-12">
          <h2 style={{ fontWeight: "bold" }}>
            Discover Premier Coworking Spaces in Faridabad
          </h2>
          <p>
            Nestled in the National Capital Region of India, Faridabad holds a
            strategic position as an industrial city in the state of Haryana.
            With roots tracing back to its founding in 1607 by Shaikh Farid,
            treasurer of Emperor Jahangir, Faridabad has long been a city of
            historical and economic significance.
            <br />
            <br />
            <strong>Industrial Heart of Haryana</strong>
            <br />
            Faridabad's journey from a quiet town to a bustling industrial city
            is remarkable. Known for housing a large number of industries,
            especially in sectors like tractors, motorcycles, switch gears,
            refrigerators, shoes, and tires, the city has been a driving force
            in Haryana's economic development. The establishment of the
            Faridabad Industrial Development Corporation (FIDC) further
            bolstered its industrial growth, attracting a skilled workforce and
            entrepreneurs alike.
            <br />
            <br />
            This industrial powerhouse has also evolved into a nurturing ground
            for new businesses and startups. The city's strategic location,
            close to the political capital, Delhi, offers a unique advantage.
            Faridabad is home to many educational institutions and universities,
            contributing to a skilled and dynamic workforce ready to join the
            evolving job market.
            <br />
            <br />
            With this industrial and educational backdrop, coworking spaces in
            Faridabad have become increasingly relevant. They offer a new-age
            solution for businesses looking for flexibility and efficiency.
            These spaces are not just about providing a desk or an office; they
            embody the spirit of collaboration and innovation, crucial for
            thriving in today's competitive environment.
            <br />
            <br />
            <strong>Adopting Work from Anywhere Culture</strong>
            <br />
            The rise of the Work from Anywhere (WFA) culture finds a strong
            foothold in Faridabad's growing business landscape. Companies,
            ranging from manufacturing giants to emerging tech startups, are
            embracing remote working models. This shift is supported by
            coworking spaces that offer:
            <br />
            <br />
          </p>
          <ul>
            <li>
              Flexibility and Freedom: Choose your work hours and location,
              aligning with personal and professional goals.
            </li>
            <li>
              Enhanced Focus: Select a work environment that minimizes
              distractions, fostering greater concentration and output.
            </li>
            <li>
              Work-Life Harmony: Achieve a better balance between professional
              commitments and personal life.
            </li>
            <li>
              Boosted Productivity: Work in environments designed for
              efficiency, enabling you to accomplish more in less time.
            </li>
          </ul>
          <br />
        </div>
      )
    case "Surat":
      return (
        <div className="col-md-12">
          <br />
          <h2 style={{ fontWeight: "bold" }}>
            Experience Superior Coworking Solutions in Surat with GoFloaters
          </h2>
          <p>
            Choosing GoFloaters for coworking spaces in Surat elevates your
            experience significantly. This platform showcases an elite
            collection of coworking environments throughout Surat, designed to
            accommodate an array of tastes and financial plans. Navigating the
            GoFloaters interface is remarkably user-friendly, facilitating an
            effortless journey to secure the perfect workspace.
            <br />
            <br /> GoFloaters is dedicated to providing transparent, competitive
            pricing and flexible booking arrangements. This commitment ensures
            that clients in Surat can access top-tier, yet affordable spaces,
            complete with all essential amenities. It's an outstanding resource
            for professionals and businesses in Surat seeking a productive and
            high-quality working environment.
            <br />
            <br />
          </p>
        </div>
      )
    case "Chandigarh":
      return (
        <div className="col-md-12">
          <br />
          <h2 style={{ fontWeight: "bold" }}>
            Booking On-Demand Coworking Space in Chandigarh
          </h2>
          <p>
            Chandigarh, the 'City Beautiful,' is a thriving hub for education,
            IT, and commerce. Known for its planned infrastructure and hosting
            numerous IT parks, it's an ideal location for both emerging startups
            and established businesses. The city's focus on flexible and hybrid
            work models makes it a prime spot for companies prioritizing
            employee well-being and innovative work environments.
            <br />
            <br /> For professionals seeking a conducive workspace, GoFloaters
            offers a wide range of options in Chandigarh. From hot desks to
            private cabins and long-term office spaces, GoFloaters caters to
            diverse needs with flexibility and convenience, ensuring a
            professional setting that suits every individual and team.
            <br />
            <br />
          </p>
        </div>
      )
    default:
      return <div className="col-md-12"></div>
  }
}

export function CoworkingContentBottom(props) {
  switch (props.city) {
    case "Bengaluru":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Coworking Locations in Bangalore
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Koramangala</h5>
          <p>
            Koramangala is the hub of Indian startup ecosystem. Flipkart and
            Swiggy were two startups that have had humble beginnings here. Not
            only this, Toshiba, Ola, Accel Partners, Instamojo, Robert Bosch,
            Meesho, Mcafee, HackerEarth, Terra Logic among others are based
            here.
            <br />
            <br />
            Located in South-East Bangalore, it is a well-to-do neighbourhood
            with all residential and commercial facilities, exceptional
            infrastructure, social life, and proximity to office locations via
            the roadways, the Kempegowda International Airport for airways
            service and Trinity station for metro rail facilities.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>HSR Layout</h5>
          <p>
            Hosur-Sarjapur Road or HSR Layout is an affluent neighbourhood
            located in South-East Bangalore. Developed in the 1980s now it has
            emerged into a leading residential area due to its proximity to IT
            Parks in Bangalore. It is also a gateway to Electronic City, a major
            IT hub of the city. HSR Layout is growing rapidly as a startup hub
            of Bangalore as it houses many startups Like Zomato, Udaan, CureFit,
            Gameskraft, OYE Fintech, ThoughtSpot, Trebound Etc. It has many
            co-working spaces like BHIVE Workspace, IndiQube, The Venture
            Studios where many startups work out of.&nbsp;&nbsp;
          </p>
          <br /> <h5 style={{ fontWeight: "bold" }}>Indiranagar</h5>
          <p>
            Indiranagar was developed in the early 1980s, and named after the
            former Prime Minister of India Smt. Indira Gandhi. Initially, the
            neighbourhood was a sight of picturesque houses, mostly owned by the
            government staff. But currently, it has been the focal point of
            Bangalore's phenomenal growth that has turned the city into a
            technology, retail, e-commerce, hospitality paradise.
            <br />
            <br />
            Top companies in and around the area are Dunzo, Boeing, IBM, Karbonn
            Mobiles, Oyo, HSBC, Oracle, Ogilvy, PwC, Cognizant, Dell, LinkedIn
            and many more. With the provision of all modern facilities and
            proximity to other prime business locations via the roadways, metro,
            and the airways, Indiranagar is a favourite destination for the
            businesses who are looking for coworking space in Bangalore.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Whitefield</h5>
          <p>
            Established in the late 1800s as a settlement for the Eurasians and
            Anglo Indians of Bangalore, Whitefield remained a quaint little
            settlement at the eastern periphery of Bangalore city till the late
            1990s when the local IT boom turned it into a major suburb.
            Whitefield in Bangalore, Karnataka was named after D.S. White, the
            founder of the European and Anglo Indian Association
            <br />
            <br />
            With the development of budget-friendly residential localities, the
            corporate hub got a major boost too. It is home to maximum
            technology parks, having thousands of companies such as Accenture,
            Hewlett Packard, AIG, Tesco, TCS, Oracle, Wipro, Unilever, Flipkart,
            SAP, Huawei, Capgemini, IBM, Dell, L&amp;T Infotech among
            others.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>J.P. Nagar</h5>
          <p>
            Jayaprakash Narayan Nagara, popularly known as J. P. Nagar, is an
            established posh upmarket residential area located in the south of
            Bangalore. Initially, it was recognised as a major housing colony
            but gradually changed into a profitable opportunity for commercial
            projects during the IT boom in the late 1990s.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Bengaluru
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <strong>Work Near Home:</strong> In most of the cities that we
              serve you can get a space within 5 kms of your home or wherever
              you are
            </li>
            <li>
              <strong>Pay-per-use:</strong> You can book coworking spaces on a
              daily basis and meeting spaces on an hourly basis and pay only for
              the time you have used it.
            </li>
            <li>
              <strong>No contracts:</strong> You don&rsquo;t have to sign any
              kind of contracts with us.&nbsp;
            </li>
            <li>
              <strong>Cost effective:</strong> We have negotiated heavily with
              our space partners to bring you savings of at least 20% if not
              more on the day pass rates and the meeting room rents.
            </li>
            <li>
              <strong>Instant Bookings:</strong> No need to call anyone or email
              anyone to check space availability. You can book coworking spaces
              instantaneously. Meeting spaces just need 30 mins of time for
              confirmation.&nbsp;&nbsp;
            </li>
            <li>
              <strong>Community Perks:</strong> GoFloaters has partnered with
              over 65+ companies to bring you over Rs 1 Crore of benefits to
              you.
            </li>
          </ul>
        </div>
      )
    case "Ahmedabad":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Ahmedabad
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <strong>Work Near Home:</strong> In most of the cities that we
              serve you can get a space within 5 kms of your home or wherever
              you are
            </li>
            <li>
              <strong>Pay-per-use:</strong> You can book coworking spaces on a
              daily basis and meeting spaces on an hourly basis and pay only for
              the time you have used it.
            </li>
            <li>
              <strong>No contracts:</strong> You don&rsquo;t have to sign any
              kind of contracts with us.&nbsp;
            </li>
            <li>
              <strong>Cost effective:</strong> We have negotiated heavily with
              our space partners to bring you savings of at least 20% if not
              more on the day pass rates and the meeting room rents.
            </li>
            <li>
              <strong>Instant Bookings:</strong> No need to call anyone or email
              anyone to check space availability. You can book coworking spaces
              instantaneously. Meeting spaces just need 30 mins of time for
              confirmation.&nbsp;&nbsp;
            </li>
            <li>
              <strong>Community Perks:</strong> GoFloaters has partnered with
              over 65+ companies to bring you over Rs 1 Crore of benefits to
              you.
            </li>
          </ul>
        </div>
      )
    case "Kochi":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Kochi
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <strong>Work Near Home:</strong> In most of the cities that we
              serve you can get a space within 5 kms of your home or wherever
              you are
            </li>
            <li>
              <strong>Pay-per-use:</strong> You can book coworking spaces on a
              daily basis and meeting spaces on an hourly basis and pay only for
              the time you have used it.
            </li>
            <li>
              <strong>No contracts:</strong> You don&rsquo;t have to sign any
              kind of contracts with us.&nbsp;
            </li>
            <li>
              <strong>Cost effective:</strong> We have negotiated heavily with
              our space partners to bring you savings of at least 20% if not
              more on the day pass rates and the meeting room rents.
            </li>
            <li>
              <strong>Instant Bookings:</strong> No need to call anyone or email
              anyone to check space availability. You can book coworking spaces
              instantaneously. Meeting spaces just need 30 mins of time for
              confirmation.&nbsp;&nbsp;
            </li>
            <li>
              <strong>Community Perks:</strong> GoFloaters has partnered with
              over 65+ companies to bring you over Rs 1 Crore of benefits to
              you.
            </li>
          </ul>
        </div>
      )
    case "Madurai":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Madurai
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <strong>Work Near Home:</strong> In most of the cities that we
              serve you can get a space within 5 kms of your home or wherever
              you are
            </li>
            <li>
              <strong>Pay-per-use:</strong> You can book coworking spaces on a
              daily basis and meeting spaces on an hourly basis and pay only for
              the time you have used it.
            </li>
            <li>
              <strong>No contracts:</strong> You don&rsquo;t have to sign any
              kind of contracts with us.&nbsp;
            </li>
            <li>
              <strong>Cost effective:</strong> We have negotiated heavily with
              our space partners to bring you savings of at least 20% if not
              more on the day pass rates and the meeting room rents.
            </li>
            <li>
              <strong>Instant Bookings:</strong> No need to call anyone or email
              anyone to check space availability. You can book coworking spaces
              instantaneously. Meeting spaces just need 30 mins of time for
              confirmation.&nbsp;&nbsp;
            </li>
            <li>
              <strong>Community Perks:</strong> GoFloaters has partnered with
              over 65+ companies to bring you over Rs 1 Crore of benefits to
              you.
            </li>
          </ul>
        </div>
      )
    case "Trichy":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Trichy
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <strong>Work Near Home:</strong> In most of the cities that we
              serve you can get a space within 5 kms of your home or wherever
              you are
            </li>
            <li>
              <strong>Pay-per-use:</strong> You can book coworking spaces on a
              daily basis and meeting spaces on an hourly basis and pay only for
              the time you have used it.
            </li>
            <li>
              <strong>No contracts:</strong> You don&rsquo;t have to sign any
              kind of contracts with us.&nbsp;
            </li>
            <li>
              <strong>Cost effective:</strong> We have negotiated heavily with
              our space partners to bring you savings of at least 20% if not
              more on the day pass rates and the meeting room rents.
            </li>
            <li>
              <strong>Instant Bookings:</strong> No need to call anyone or email
              anyone to check space availability. You can book coworking spaces
              instantaneously. Meeting spaces just need 30 mins of time for
              confirmation.&nbsp;&nbsp;
            </li>
            <li>
              <strong>Community Perks:</strong> GoFloaters has partnered with
              over 65+ companies to bring you over Rs 1 Crore of benefits to
              you.
            </li>
          </ul>
        </div>
      )
    case "Visakhapatnam":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Visakhapatnam
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <strong>Work Near Home:</strong> In most of the cities that we
              serve you can get a space within 5 kms of your home or wherever
              you are
            </li>
            <li>
              <strong>Pay-per-use:</strong> You can book coworking spaces on a
              daily basis and meeting spaces on an hourly basis and pay only for
              the time you have used it.
            </li>
            <li>
              <strong>No contracts:</strong> You don&rsquo;t have to sign any
              kind of contracts with us.&nbsp;
            </li>
            <li>
              <strong>Cost effective:</strong> We have negotiated heavily with
              our space partners to bring you savings of at least 20% if not
              more on the day pass rates and the meeting room rents.
            </li>
            <li>
              <strong>Instant Bookings:</strong> No need to call anyone or email
              anyone to check space availability. You can book coworking spaces
              instantaneously. Meeting spaces just need 30 mins of time for
              confirmation.&nbsp;&nbsp;
            </li>
            <li>
              <strong>Community Perks:</strong> GoFloaters has partnered with
              over 65+ companies to bring you over Rs 1 Crore of benefits to
              you.
            </li>
          </ul>
        </div>
      )
    case "Gaziabad":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Ghaziabad
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <strong>Work Near Home:</strong> In most of the cities that we
              serve you can get a space within 5 kms of your home or wherever
              you are
            </li>
            <li>
              <strong>Pay-per-use:</strong> You can book coworking spaces on a
              daily basis and meeting spaces on an hourly basis and pay only for
              the time you have used it.
            </li>
            <li>
              <strong>No contracts:</strong> You don&rsquo;t have to sign any
              kind of contracts with us.&nbsp;
            </li>
            <li>
              <strong>Cost effective:</strong> We have negotiated heavily with
              our space partners to bring you savings of at least 20% if not
              more on the day pass rates and the meeting room rents.
            </li>
            <li>
              <strong>Instant Bookings:</strong> No need to call anyone or email
              anyone to check space availability. You can book coworking spaces
              instantaneously. Meeting spaces just need 30 mins of time for
              confirmation.&nbsp;&nbsp;
            </li>
            <li>
              <strong>Community Perks:</strong> GoFloaters has partnered with
              over 65+ companies to bring you over Rs 1 Crore of benefits to
              you.
            </li>
          </ul>
        </div>
      )
    case "Coimbatore":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Coimbatore
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <strong>Work Near Home:</strong> In most of the cities that we
              serve you can get a space within 5 kms of your home or wherever
              you are
            </li>
            <li>
              <strong>Pay-per-use:</strong> You can book coworking spaces on a
              daily basis and meeting spaces on an hourly basis and pay only for
              the time you have used it.
            </li>
            <li>
              <strong>No contracts:</strong> You don&rsquo;t have to sign any
              kind of contracts with us.&nbsp;
            </li>
            <li>
              <strong>Cost effective:</strong> We have negotiated heavily with
              our space partners to bring you savings of at least 20% if not
              more on the day pass rates and the meeting room rents.
            </li>
            <li>
              <strong>Instant Bookings:</strong> No need to call anyone or email
              anyone to check space availability. You can book coworking spaces
              instantaneously. Meeting spaces just need 30 mins of time for
              confirmation.&nbsp;&nbsp;
            </li>
            <li>
              <strong>Community Perks:</strong> GoFloaters has partnered with
              over 65+ companies to bring you over Rs 1 Crore of benefits to
              you.
            </li>
          </ul>
        </div>
      )
    case "Chennai":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Coworking Locations in Chennai
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Old Mahabalipuram Road&nbsp;</h5>
          <p>
            This stretch of road starts from Madhya Kailash till it ends in
            Mahabalipuram. This road is also called the IT Expressway with many
            IT parks and large IT MNC dotting the road. It is also well-known
            for many educational, technical institutions and medical
            laboratories. Startups and service companies prefer to take up space
            on this road as the talent pool is available to tap.&nbsp;
          </p>
          <br></br>
          <h5 style={{ fontWeight: "bold" }}>Guindy</h5>
          <p>
            A largely industrial district, Guindy is also home to Guindy
            National Park. The Kathipara Junction with its butterfly flyover is
            a prominent landmark in this area. Three main roads of Chennai
            namely Anna Salai, Mount-Poonamallee Road, Inner Ring Road, 100 Feet
            Road or Jawaharlal Nehru Road, and GST Road meet here. Guindy is
            well connected by road and train services. It is also well connected
            by the trains with MRTS and Metro station. Guindy is also located 10
            km away from the airport. Due to its connectivity many startups,
            small businesses and large companies have Guindy as their first
            preference when it comes to office space.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Teynampet</h5>
          <p>
            Teynampet is one of the busiest commercial localities in the city of
            Chennai. Teynampet is along Anna Salai, the arterial road of
            Chennai. Teynampet also has some of the poshest pieces of real
            estate and properties in Chennai. Teynampet is also well connected
            via public bus and metro transport. Startups prefer Teynampet for
            its connectivity.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Nungambakkam</h5>
          <p>
            Nungambakkam is one of the oldest parts of Chennai. Located along
            Anna Salai, Nungambakkam is the official downtown of Chennai. The
            neighborhood is home to many multi-national commercial
            establishments, important government offices, foreign consulates,
            sprawling educational institutions, shopping malls, sporting
            facilities, tourist spots, star hotels, restaurants, and cultural
            centers. Nungambakkam is also a prime residential area in Chennai.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Anna Nagar</h5>
          <p>
            Anna Nagar is located in the north-western part of Chennai. It is
            one of the prime residential areas in Chennai and is home to several
            prominent doctors, lawyers and politicians. Real estate prices are
            among the highest in the city. Anna Nagar has several established
            schools and colleges, places of worship and shopping areas.&nbsp;
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Chennai
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.&nbsp;
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Hyderabad":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Coworking Locations in Hyderabad
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>HITEC City</h5>
          <p>
            HITEC CITY, the acronym for Hyderabad Information Technology and
            Engineering Consulting City, is a hub of Information Technology,
            Financial Business, Medical, Engineering and Bioinformatics.
            Popularly acclaimed at &lsquo;Cyberabad&rsquo;, this city spans over
            200 acres of land. Being the center of all IT action, it is also the
            base for some of the most popular coworking spaces and office spaces
            for rent.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Madhapur</h5>
          <p>
            What belonged to an era of suburbs, rocky villages and small towns
            in the 1990s, is the current nucleus of all things IT. Madhapur,
            today boasts of the best coworking spaces in and across Hyderabad
            and also houses the now famous HITEC City. The destination is
            rapidly becoming ideal for business meetings.
          </p>
          <br /> <h5 style={{ fontWeight: "bold" }}>Jubilee Hills</h5>
          <p>
            Jubilee Hills is a luxurious neighbourhood spread across the west of
            Hyderabad. It is one of the high-priced residential, recreational,
            political and commercial localities of the city with land prices
            crossing the sky. This suburb is sandwiched between the wealthy
            commercial district of Banjara Hills and is located within two
            kilometres of Hyderabad's IT hub of HITEC City.
            <br />
            <br />
            Globally known companies like PricewaterhouseCoopers (PWC), ICICI
            and HDFC banks, Seaways, Gateway Media, Lanco Global Systems and
            many more have their headquarters here.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Begumpet</h5>
          <p>
            Begumpet (&quot;Begum's Place&quot;) is a part of Secunderabad,
            Hyderabad. Begumpet is named after the daughter of the sixth Nizam
            (Mahbub Ali Khan, Asaf Jah VI), Basheer Unnisa Begum. The
            neighbourhood is one of the crucial commercial and residential hubs
            sandwiched between Secunderabad and Hyderabad.
            <br />
            <br />A lucrative business destination for Information Technology
            (IT) companies, it is witnessing a spur in coworking spaces with all
            basic facilities. Begumpet Railway Station provides rail
            connectivity to the area. Other MMTS stations in the vicinity
            include Sanjeevaiah Park and James Street. State-owned TSRTC runs
            the city bus service, connecting Begumpet to major parts of the
            city.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Banjara Hills</h5>
          <p>
            Banjara Hills is an urban commercial centre and one of the most
            affluent neighbourhoods in Hyderabad, Telangana, India. This is an
            upmarket locality close to Jubilee Hills. This area was a hilly
            forest and was least inhabited in the past. It is considered as the
            most expensive zip code in India.
            <br />
            <br />
            This neighbourhood has now been completely transformed and comprises
            prestigious malls like GVK One, City Centre, Midtown, hotels such as
            Taj Mahal, Park Hyatt, ITC, Treebo, The Westin, restaurants like
            Barbeque Nation, Hard Rock Cafe, Bikanervala, Olive Bistro, and
            world-renowned multinational companies like Genpact, Infosys,
            Microsoft India, Hitachi Consulting and many more.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Hyderabad
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Mumbai":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>Coworking Space in Mumbai </h4>

          <h4 style={{ fontWeight: "bold" }}>
            Top Office Space Locations in Mumbai
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Navi Mumbai</h5>
          <p>
            Navi Mumbai is one of the prime locations for coworking spaces in
            Mumbai. The city is divided into two parts, North Navi Mumbai and
            South Navi Mumbai. It houses a wide range of major educational
            institutions, MNCs like Reliance, Accenture, Siemens, L&amp;T,
            recreational facilities Central Park, Golf Course, Wonder Park etc.
            This destination is the new preference for shared office spaces in
            Mumbai. The basic amenities include parking, spacious floors,
            electricity back up, proximity to the railway station and airport
            among others.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Andheri and neighbouring areas</h5>
          <p>
            Andheri is the heart of Mumbai. A luxurious locality with renowned
            national and international offices, along with prime residential
            societies. It is one of the growing coworking space destinations in
            Mumbai for many commercial, financial and media houses. The key
            reasons for the area&rsquo;s growth are its proximity to the airport
            and availability of all amenities including an efficient
            transportation system.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Nariman Point</h5>
          <p>
            Nariman point is known as the home to all the famous banks,
            financial institutions, and many top business houses. From huge car
            parking space to well-maintained buildings, Nariman Point is one of
            the renowned commercial hubs in India.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Thane</h5>
          <p>
            New buildings, presence of all the important amenities and the house
            for all types of office spaces for IT &amp; ITES companies. One of
            the attractive specialties of the place is availability of
            inexpensive office spaces. Not only this, you can get larger floor
            areas for less cost when compared to other areas.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Worli</h5>
          <p>
            Worli is one of Mumbai's affluent areas in South Mumbai, offering a
            charm of both the new and old. The place attracts a lot of
            commercial development annually by big players ensuring 24-hour
            power backup, spacious office spaces, air conditioning, car parking
            and other basic facilities. With this, proximity to the nearest
            railway station and airport makes this destination the most ideal
            out of all.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your Coworking space in Mumbai
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Pune":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Coworking Locations in Pune
          </h4>
          <br /> <h5 style={{ fontWeight: "bold" }}>Yerawada</h5>
          <p>
            Also known as Yeraoda, Yerwada is home to famous places like Tech
            Park One, Commerce zone, Business bay, and Muttha Towers. These
            names are enough to define the infrastructural and commercial power
            of this area.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Baner</h5>
          <p>
            Baner is widely known for its traditional rituals and bhakti
            aradhana. However, the place is well known for commercial setups
            too. Prabhavee Tech Park and Nanospace IT Park are the two famous
            and must-go places in Baner.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Kharadi</h5>
          <p>
            Located at the banks of Mula-mutha river, Kharadi is a suburb in
            Pune, known for IT companies. EON IT park and world trade center are
            the two attractions of the place.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Hinjawadi</h5>
          <p>
            Pune&rsquo;s Hinjewadi area has travelled far from rural to urban at
            the speed of IT. Once an anonymous destination comprising small
            villages, Hinjewadi is now a crucial spot of real estate. With the
            inauguration of the 2800 acre Rajiv Gandhi Infotech Park and
            subsequent entry of IT companies, this area has witnessed a huge
            growth in its working population.&nbsp;
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Magarpatta</h5>
          <p>
            Magarpatta is a 450 acre, privately owned community, located in the
            Hadapsar area of Pune. It is a rapidly growing commercial hub with
            companies like Deutsche Bank, WNS Global Services, Accenture, HCL
            Technologies among other commercial setups.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Pune
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "New Delhi":
      return (
        <div className="col-md-12">
          <br />
          <h4 style={{ fontWeight: "bold" }}>Coworking Spaces in New Delhi</h4>
          <br />
          <p>
            New Delhi, the heart of India, is not only the political capital but
            also a burgeoning hub for entrepreneurs, freelancers, and startups.
            Coworking spaces in New Delhi are designed with a deep understanding
            of the needs of modern entrepreneurs and professionals. They provide
            an ideal mix of collaborative open spaces and private areas for
            focused work. These spaces often come equipped with state-of-the-art
            amenities, high-speed internet,{" "}
            <a href="https://gofloaters.com/meeting-spaces/new-delhi/">
              meeting rooms
            </a>
            , and event spaces, catering to the diverse requirements of their
            members.
            <br />
            <br />
            Furthermore, the strategic location of New Delhi, with its robust
            infrastructure and connectivity, adds to the allure of coworking
            spaces in the city. Its extensive metro network, easy accessibility
            to major business districts, and proximity to government bodies make
            it a preferred location for businesses looking to make a mark in the
            Indian market.
            <br />
            <br />
            In addition to the practical benefits, coworking spaces in New Delhi
            offer a chance to be part of a community that thrives on diversity
            and creativity. Regular networking events, workshops, and
            collaborative opportunities allow members to connect, learn, and
            grow together.
            <br />
            <br />
          </p>
          <h4 style={{ fontWeight: "bold" }}>
            Top Coworking Locations in New Delhi
          </h4>
          <br /> <h5 style={{ fontWeight: "bold" }}>Connaught Place</h5>
          <p>
            A shoppers paradise and a well-known financial, commercial and
            business hub in central Delhi, Connaught Place offers a lot more
            than this. From historic monuments like Jantar Mantar and Agrasen ki
            Baoli, well-known shopping streets like Janpath, religious places
            like Hanuman Mandir and Gurudwara Bangla Sahib, iconic restaurants
            like Sarvana Bavan and Indian Coffee House, headquarters of
            prominent Indian firms like Hindustan Times and British Broadcasting
            Corporation (BBC), the place is a fusion of both the ancient and
            modern.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Rajouri Garden</h5>
          <p>
            Rajouri Garden is a popular residential and market place in West
            Delhi and is marked by its distinct Delhi architecture. It is a home
            of budget-friendly work stations for creative freelancers, newly
            established startups, small and medium enterprises, corporates
            etc.&nbsp;
          </p>
          <br /> <h5 style={{ fontWeight: "bold" }}>Nehru Place</h5>
          <p>
            Nehru Place derives its name from the first Prime Minister of India,
            Pandit Jawaharlal Nehru. The neighbourhood is an epicentre of all
            Information Technology hardware, such as computers, networking
            resources, software, documentation facilities and allied services
            and hence, it is a computer fanatic&rsquo;s shopping paradise. Along
            with this, it is a favourite destination for Generation Y as it
            houses well-known hotels, restaurants and multiplexes in its
            vicinity.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Hauz Khas</h5>
          <p>
            Hauz Khas is one of the favourite destinations of millennials,
            giving a feel of both the urban and rural. Well known in medieval
            times, the Hauz Khas village has amazing buildings built around the
            reservoir. There&rsquo;s a lot one can do in this developing
            neighbourhood. Not only this, but a lot of startups and SMEs are
            also opening their offices here due to the growing innovative
            culture.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Greater Kailash</h5>
          <p>
            Located along the Outer Ring Road, Greater Kailash is one of the
            well-to-do neighbourhoods in South Delhi. Greater Kailash is a
            residential area in South Delhi comprising several neighborhoods and
            multiple markets. It is a synthesis of posh houses and bungalows,
            affluent N and M block markets, cafes, restaurants and branded
            retail stores. Along with these, it is gradually transforming into a
            major workplace hub for budding entrepreneurs, creative freelancers
            and newly born startups.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in New Delhi
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Indore":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Indore
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Kolkata":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Kolkata
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Noida":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Coworking Locations in Noida
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Noida City Centre</h5>
          <p>
            Construction is currently underway for this project. The proposed
            plot of land that is to be developed is around 99 hectares in area.
            The city centre will bring together shopping arcades, opulent office
            spaces and international retail food chains along with multiplexes
            and 5-star hotels.
          </p>
          <br /> <h5 style={{ fontWeight: "bold" }}>Sector 18</h5>
          <p>
            The commercial complex in this centre has turned out to be a centre
            point for trade and commercial activities. This is an ideal location
            for traders as Sector 18 provides office facilities and
            opportunities for commercial expansion. The malls here offer a gamut
            of international and national clothing brands and restaurant chains
            that suit all pockets. It also has 5-star hotels and multiplexes.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Sector 62</h5>
          <p>
            It is a noteworthy location in central Noida. The commercial and
            residential areas are clearly demarcated here. The Noida campuses of
            some of the leading universities of India like, IIM Lucknow,
            Symbiosis Center for Management Studies and Symbiosis Law School are
            located here. It also houses branches of State Bank of India, HDFC
            Bank, ICICI Bank, IndusInd Bank and other prominent banks of India.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Noida
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Gurugram":
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Top Coworking Locations in Gurugram
          </h4>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Udyog Vihar</h5>

          <p>
            Udyog Vihar is located near Delhi-Gurgaon Border and 8 km from
            Indira Gandhi International Airport on National Highways 8. The
            location is planned and well connected with roads. Rapid Metro rail
            is the most feasible transport option available. DLF Phase III is
            the nearest metro station to Udyog Vihar which is connected to
            Sikandarpur Metro Station, which further connects metro to different
            parts of Delhi and Gurgaon. Hyatt Place, The Leela, Trident Hotel,
            The Oberoi and Country Inn Carlson are some of the famous hotels
            near Udyog Vihar. It is one of the best locations for office space
            in Gurgaon.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Sector- 54</h5>
          <p>
            From the point of connectivity, Sector-54 chowk itself is a metro
            station, from where one can easily reach out to Delhi in just a few
            minutes. HCL healthcare clinic and Gmerk hospital is in the radius
            of 10 Kms. South point Mall, Fabindia and Sahara Mall are the
            all-time favorite hotspots for fun lovers and visitors. Also, the
            Suncity project in sector-54 offers a best residential premise as
            per your budget, if you are looking to settle down there. Sector-54
            well supports the co-working spaces in Gurgaon, meeting rooms and
            conference rooms.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>Sector-48 &amp; 49</h5>
          <p>
            Both the sectors are known for its excellent education facilities
            including world class schools such as G.D. Goenka public school,
            Eden castle school, Budding minds, GEMS modern academy etc. The area
            has Merchant marine academy, E.C.H.S Polyclinic, Quest diagnostics
            and many more with world class medical facilities. If you are a
            foodie, you have the choice of Cyber adda 24, Mehfil Restaurant,
            Subway, the coriander, Colonel&rsquo;s kitchen and many more.
          </p>
          <br />
          <h5 style={{ fontWeight: "bold" }}>DLF Cyber City</h5>
          <p>
            As the name suggests, Cyber city is the Cyber hub of big corporate
            and IT Industries from all over the world. This is a highly
            recommended location, if you are looking for office space for rent
            or shared office space or co-working space in Gurgaon. DLF Cyber
            city and Udyog Vihar are only 2-3 Kms. Apart from that, facilities
            are almost similar to those in Udyog Vihar. Presence of several
            companies in a small area makes this a busy part of the city.
          </p>
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in Gurugram
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
    case "Surat":
      return (
        <div className="col-md-12">
          <br />
          <h2 style={{ fontWeight: "bold" }}>
            Experience Superior Coworking Solutions in Surat with GoFloaters
          </h2>
          <p>
            Choosing GoFloaters for coworking spaces in Surat elevates your
            experience significantly. This platform showcases an elite
            collection of coworking environments throughout Surat, designed to
            accommodate an array of tastes and financial plans. Navigating the
            GoFloaters interface is remarkably user-friendly, facilitating an
            effortless journey to secure the perfect workspace.
            <br />
            <br /> GoFloaters is dedicated to providing transparent, competitive
            pricing and flexible booking arrangements. This commitment ensures
            that clients in Surat can access top-tier, yet affordable spaces,
            complete with all essential amenities. It's an outstanding resource
            for professionals and businesses in Surat seeking a productive and
            high-quality working environment.
            <br />
            <br />
          </p>
        </div>
      )
    default:
      return (
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>
            Why Choose GoFloaters to book your coworking space in {props.city}
          </h4>
          <p>
            GoFloaters has been in the space of helping individuals and teams
            find flexible and affordable workspaces for over 3 years now.
            GoFloaters was started with a vision to help anyone get an office
            space when they want, where they want and within their budget. We
            set out to build office spaces for a distributed world where
            individuals and teams should be able to work near home.
          </p>
          <br />
          <p>
            Following are the advantages of booking coworking spaces and meeting
            spaces on the GoFloaters app:
          </p>
          <ul>
            <li>
              <p>
                <strong>Work Near Home :</strong> In most of the cities that we
                serve you can get a space within 5 kms of your home or wherever
                you are
              </p>
            </li>
            <li>
              <p>
                <strong>Pay-per-use : </strong>You can book coworking spaces on
                a daily basis and meeting spaces on an hourly basis and pay only
                for the time you have used it.
              </p>
            </li>
            <li>
              <p>
                <strong>No contracts :</strong> You don&rsquo;t have to sign any
                kind of contracts with us.&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Cost effective :</strong> We have negotiated heavily
                with our space partners to bring you savings of at least 20% if
                not more on the day pass rates and the meeting room rents.
              </p>
            </li>
            <li>
              <p>
                <strong>Instant Bookings : </strong>No need to call anyone or
                email anyone to check space availability. You can book coworking
                spaces instantaneously. Meeting spaces just need 30 mins of time
                for confirmation.&nbsp;&nbsp;
              </p>
            </li>
            <li>
              <p>
                <strong>Community Perks :</strong> GoFloaters has partnered with
                over 65+ companies to bring you over Rs 1 Crore of benefits to
                you.
              </p>
            </li>
          </ul>
        </div>
      )
  }
}
export function CoworkingContentLocality(props) {
  switch (props.city) {
    case "Chennai":
      if (props.locality === "Perungudi")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Perungudi
            </h4>
            <p>
              Perungudi, a rapidly growing suburb of Chennai, has established
              itself as a notable tech hub, attracting a diverse mix of IT
              companies, startups, and entrepreneurs. Nestled along the IT
              corridor of Chennai, Perungudi blends the charm of its natural
              landscapes with the bustle of tech activities, creating a unique
              environment conducive to innovation and growth. This area, with
              its blend of modern infrastructure and green spaces, offers an
              ideal setting for professionals seeking a balance between work and
              wellness.
              <br />
              <br />
              The coworking spaces in Perungudi are a reflection of this
              dynamic. Designed to cater to the needs of a modern workforce,
              these spaces provide the perfect amalgamation of functionality and
              comfort. They offer a variety of amenities, from high-speed
              internet and ergonomic workstations to collaborative areas and{" "}
              <a href="https://gofloaters.com/meeting-spaces/chennai/all">
                private meeting rooms
              </a>
              , all tailored to facilitate productivity and creativity. For
              entrepreneurs and freelancers, these coworking spaces are not just
              about affordability and convenience; they are vibrant communities
              that foster networking, learning, and growth, making Perungudi an
              attractive destination for anyone looking to thrive in Chennai's
              burgeoning tech landscape.
              <br />
              <br />
            </p>
          </div>
        )
    case "Hyderabad":
      if (props.locality === "Madhapur")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Madhapur, Hyderabad
            </h4>
            <p>
              Madhapur, the heart of Hyderabad's technological revolution, is a
              vibrant hub known for its dynamic blend of technology and culture.
              It's a neighborhood bustling with upscale eateries, shopping
              centers, and tech giants. Hosting prestigious companies like
              Google, Deloitte, and Microsoft, Madhapur epitomizes a high-tech,
              professional environment ideal for businesses and entrepreneurs.
              <br />
              <br />
              The coworking spaces in Madhapur are renowned for their
              state-of-the-art amenities and contemporary design, offering a
              stimulating yet comfortable working atmosphere. With its superior
              infrastructure and strategic location, including easy access to
              HITEC City and major transport links, Madhapur stands as a top
              choice for professionals seeking a dynamic and accessible
              workspace in Hyderabad.
              <br />
              <br />
            </p>
          </div>
        )
    case "Noida":
      if (props.locality === "Sector 62")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Sector 62, Noida
            </h4>
            <p>
              Sector 62, Noida, stands as a prominent hub for IT companies and
              educational institutions. This area has rapidly transformed into
              one of the most dynamic and thriving neighborhoods in Noida,
              resonating with a vibrant, intellectual, and entrepreneurial
              spirit. With its blend of modern amenities, lush green parks, and
              a variety of eateries and leisure activities, Sector 62 offers an
              ideal environment for fostering productivity and innovation.
              <br />
              <br />
              This transformation is reflected in the success stories of
              numerous startups and tech companies that have roots in Sector 62.
              Notable names include Paytm, Samsung, TCS, and several emerging
              startups that have carved their niches in various industries.
              These organizations epitomize the entrepreneurial zeal and
              technological prowess that Sector 62 is known for.
              <br />
              <br />
              The presence of several coworking spaces in Sector 62 is a
              testament to its status as a thriving business ecosystem. These
              spaces are thoughtfully designed to strike the perfect balance
              between collaborative working environments and private, focused
              workspaces. For entrepreneurs and startups, coworking spaces in
              Sector 62 offer a cost-effective and flexible alternative to
              traditional office leasing. With options catering to diverse
              budgets and preferences, there is a coworking space for every
              requirement.
              <br />
              <br />
              Moreover, Sector 62's strategic location and excellent
              connectivity to the
              <a href="https://gofloaters.com/coworking-spaces/noida/all">
                rest of Noida
              </a>{" "}
              and Delhi-NCR make it an exceptionally convenient place for
              professionals. Its proximity to major highways, the Noida
              Electronic City Metro Station, and various residential areas
              enhances its appeal as a prime location for work and business
              meetings.
              <br />
              <br />
            </p>
          </div>
        )
    case "Bengaluru":
      if (props.locality === "HSR Layout")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in HSR Layout, {props.city}
            </h4>
            <p>
              Vibrant with life, HSR Layout is a hidden gem that is full of
              possibilities. It is located at the heart of the city, in close
              proximity to Whitefield, Koramangala, Electronic City and many
              more. HSR layout has a life of its own. Everything one could need
              is readily available - corporate offices, restaurants, hospitals
              and stores of all varieties!
              <br />
              <br />
              In addition to all this, it has also become the base from which
              countless startups have emerged. These startups come in all
              variations- fintech, edtech and every other imaginable industry.
              It is the host of several big names including KhataBook, NestAway,
              ZoloStays, Simplilearn and Vedantu.
              <br />
              <br />
              Coworking in HSR Layout is a great idea for productivity and
              networking.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Koramangala")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Koramangala, {props.city}
            </h4>
            <p>
              Koramangala is home to several IT companies and colleges. Catering
              to this youthful, intelligent and boisterous energy it has
              expanded into one of the coolest neighbourhoods in Bangalore. With
              the best restaurants, posh neighbourhoods and an abundance of
              activities to engage in it offers the best facilities and
              environment for enhanced productivity.
              <br />
              <br />
              This is evident from the amalgam of startups that have emerged and
              achieved incredible success in Koramangala. These startups include
              - Lookup, Instamojo, Explara, Furlenco, HackerEarth and many more.
              <br />
              <br />
              It is no wonder that Koramangala has innumerable coworking spaces.
              The hotdesks offered here are designed to provide the optimal
              balance between communal working to facilitate the ebb and flow of
              ideas with the privacy and peaceful silence to work effectively
              away from home. Most entrepreneurs start their ventures out of
              coworking spaces, as this is a more economical option in
              comparison to leasing office space. Koramangala with its wide
              range of options, has coworking spaces for all budgets and
              expectations.
              <br />
              <br />
              In addition to this, its high connectivity to the rest of
              Bangalore makes it an ideal place to work and host meetings.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Indiranagar")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Indiranagar, {props.city}
            </h4>
            <p>
              Indiranagar is a stylish and exclusive neighbourhood, located in
              East Bangalore. Every street is immersed in colour, life and
              vibrance with their restaurants, shops and boutiques. It serves as
              a base for several premier Indian and International brands.
              <br />
              <br />
              Indiranagar being a posh area, offers the best of services and
              amenities. This makes it an ideal place to work. There is an
              impressive collection of corporate offices for famous companies in
              and around Indiranagar including Dunzo, Boeing, HSBC, HP, Dell,
              LinkedIn, IBM, Oracle and many more!
              <br />
              <br />
              With its enumerable IT companies, universities and tech parks, it
              has spectacular infrastructure and is miles ahead of other
              localities in terms of technological advancements and hospitality
              offered.
              <br />
              <br />
              Indiranagar is very well connected, thanks to the metro line and
              100 Feet Road. This makes it very convenient and accessible for
              commuters.
              <br />
              <br />
              Countless coworking spaces with refined corporate setting, privacy
              and comforting ambience are found here. Working in Indiranagar is
              nothing short of paradise.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Whitefield")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Whitefield, Bengaluru
            </h4>
            <p>
              Whitefield, a prominent and bustling tech hub, is located in the
              eastern part of Bengaluru. Known for its cosmopolitan vibe,
              Whitefield is filled with an array of upscale restaurants, malls,
              and lifestyle stores, catering to a diverse and international
              community. It's a major center for the IT industry, housing
              numerous tech giants and startups. This locality, characterized by
              its sophisticated charm, provides top-tier services and amenities,
              making it a prime workspace destination. Whitefield is home to an
              array of prestigious corporate offices, including giants like IBM,
              Oracle, TCS, and Accenture, among others. The area's wealth of IT
              companies, tech parks, and its modern infrastructure place it at
              the forefront of technological progress and professional amenities
              in Bengaluru.
              <br />
              <br />
              Whitefield's connectivity is another of its strengths, with
              excellent road networks and proximity to key areas in Bengaluru.
              This ensures easy accessibility for those commuting to and from
              the area.
              <br />
              <br />
              The coworking spaces in Whitefield are known for their upscale
              corporate environment, offering privacy and a comfortable
              ambiance. They provide the perfect setting for professionals and
              businesses seeking a high-quality working environment in
              Bengaluru.
              <br />
              <br />
            </p>
          </div>
        )
    case "Mumbai":
      if (props.locality === "Andheri")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Andheri, {props.city}
            </h4>
            <p>
              Cool places to work from Andheri
              <br />
              <br />
              Andheri is a huge suburb in western Mumbai consisting of premium
              residential, commercial and financial areas. The demand of this
              area has increased in the past few years due to the expansion of
              the metro rail in Mumbai, improving its potential as one of the
              prime locations of Mumbai.
              <br />
              <br />
              <b>Location:</b> Andheri is located in the western part of the
              city. Divided by the Mumbai local railways, it is divided in
              Andheri West and Andheri East with each having their distinct
              characteristics. Andheri west has become a sought after
              residential area with posh locations like sea facing Versova and
              busy commercial markets in Lokhandwala. Andheri east is full of
              commercial establishments with proximity to industrial and export
              processing zones and the airport.
              <br />
              <br />
              <b>Facilities:</b> Andheri offers a myriad of things to do,
              professionally and recreationally. It has a lot of corporate
              offices, banks, retail and entertainment hubs, hospitals, schools,
              restaurants. It is also home to some of the biggest entertainment
              production houses creating ample job opportunities with constant
              need for office space. There are accommodations available which
              are suitable for all budgets.
              <br />
              <br />
              <b>Infrastructure:</b> Andheri is a major transportation hub. With
              easy access to public transport like Mumbai metro, local trains,
              bus and rickshaw, Andheri is an excellent locality for any
              commercial purpose. It has good road connectivity with other parts
              of the city.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Thane")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Thane, Mumbai
            </h4>
            <p>
              Bustling with energy and enterprise, Thane is emerging as a go-to
              destination for startups and entrepreneurs in Mumbai.
              Strategically located between Mumbai and Navi Mumbai, it offers
              excellent connectivity while retaining its own unique vibe. Known
              for its affordability and good social infrastructure, Thane has
              become the breeding ground for innovators across industries like
              fintech, healthtech, media and e-commerce among others.
              <br />
              <br />
              Companies like CreditMantri, KreditBee, Druva, Pubmatic and Pepper
              Content have chosen Thane as their base to grow from. Coworking
              spaces allow these young companies to leverage community and
              collaboration for better productivity. Prominent coworking brands
              like Awfis, CoWrks, 91Springboard and WeWork can be found dotting
              the area. With metros, malls, hospitals and schools nearby,
              coworking in Thane makes for an ideal launchpad for your next big
              idea!
              <br />
              <br />
              The future looks bright for Thane and it is definitely a location
              worth considering if you are looking to startup or freelance from
              a coworking space in Mumbai.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Santacruz West")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Santacruz West, {props.city}
            </h4>
            <p>
              Santacruz is a western suburb of Mumbai, and home to International
              and domestic airports. The location enjoys excellent connectivity
              to all parts of the city via the expressway, Mumbai Suburban
              Railway Lines, and the Mumbai Metro. Some of the things that make
              this a popular destination to live and work include:
              <br />
              <br />
              <b>Centrally located:</b> Santacruz is located between the upscale
              residential suburb of Juhu, Vileparle, and Khar. Proximity to the
              Airport and Highways makes Santacruz one is the premium suburb of
              Mumbai geographically. Import and export trade businesses have
              offices near the airport. The location has become the link for
              accessing the central suburbs of Mumbai via the SCLR expressways.
              Proximity to the business hub BKC is another added advantage for
              the location.
              <br />
              <br />
              <b>Facilities:</b> Santacruz offers abundant opportunities to
              maintain a good lifestyle and healthy work-life balance. The
              location offers a wide variety of commercial establishments,
              recreational activities, entertainment options, educational
              institutions. Corporate headquarters of many banks, fashion
              brands, upscale retail outlets are located here.
              <br />
              <br />
              <b>Infrastructure:</b> Santacruz has industrial processing areas
              like SEEPZ, premium retail outlets of high fashion houses,
              educational institutions like SNDT College and the University of
              Mumbai. There is excellent connectivity to other parts of the city
              through a robust rail network and road connections. Numerous
              skywalks have been made for easy pedestrian flow.
              <br />
              <br />
            </p>
          </div>
        )
    case "Pune":
      if (props.locality === "Baner")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Baner, {props.city}
            </h4>
            <p>
              Baner is a popular suburb in Pune. Pune is one of the heavily
              industrialised zones in the country that have many workspaces and
              other coworking spaces in and around the area to accommodate the
              workforce that lives in the city.
              <br />
              <br />
              Located in the Western Corridor of Pune, Baner is home to some of
              the biggest manufacturing units of automobiles and other various
              goods. It also comprises many IT companies and other firms that
              have their headquarters in the area. A new rise in the number of
              co-working spaces has made it better for the people who work in
              the area to use the facilities and work remotely from the place of
              their choice.
              <br />
              <br />
              These coworking spaces in Baner have many facilities that they
              provide for the people. Facilities such as fast Wi-Fi, freshly
              brewed coffee, projector rooms, TVs for presentations, dedicated
              meeting rooms and hot desks. They provide everything and you will
              have to pay by the hour or per day, depending on your usage.
              <br />
              <br />
              Co-working spaces in the Magarpatta city, Cybercity, Ashok Chakra
              circle and many other places help people who live and work in and
              around the area to choose the coworking space of their choice and
              lets them work remotely with all the available facilities they
              require for working during the day and night. If you want to know
              where you can book such spaces, head over to GoFloaters and choose
              the coworking space of your choice now. <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Viman Nagar")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Viman Nagar, {props.city}
            </h4>
            <p>
              Viman Nagar is an affluent residential and retail neighbourhood in
              the Eastern Metropolitan Corridor of Pune and serves as one of the
              most prominent regions in the city. It is in proximity to the Pune
              International Airport. Viman Nagar is very close to Pune airport.
              This is the main reason behind its name, because of the
              near-airport the rates of real-estate are very high in Viman Nagar
              compared to the entire Pune district. Besides this, many companies
              like Tech Mahindra, Viera Tech, Indigo Architects, Ericsson Global
              India Services Pvt Ltd, etc are in the area which caters to 1000s
              of people working in the area. Coworking spaces in this area are
              thriving and they almost get many people who work in here to their
              spaces almost every day. These coworking spaces also provide some
              of the best in class facilities they can offer to a person. They
              provide the fastest Wi-Fi possible, hot desks, private meeting
              rooms to have meetings and discussions, TVs for presentations,
              projectors and many more things that are required for a suitable
              working space remotely. With these coworking spaces, individuals
              get a lot of perspectives and help with their growth as well. If
              you want such spaces, then head over to GoFloaters and choose the
              space of your choice. <br />
              <br />
            </p>
          </div>
        )

    case "Kolkata":
      if (props.locality === "AJC Bose Road")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in AJC Bose Road, {props.city}
            </h4>
            <p>
              Acharya Jagadish Chandra Bose Road, earlier known as Lower
              Circular Road, and its continuation northwards called Acharya
              Prafulla Chandra Road (Upper Circular Road), is the longest and
              the most important north-south thoroughfare in Kolkata, India. It
              houses the Steel Authority of India, The Times of India and many
              other companies that are present in the area. Most of these spaces
              have coworking spaces that provide the usual facilities that are
              provided by most of the coworking spaces across the city. They
              provide the fastest Wi-Fi possible, hot desks, private meeting
              rooms to have meetings and discussions, TVs for presentations,
              projectors, etc. Although there are government offices in this
              area it is not as famous for coworking spaces, but people still
              use it for meetings and many other things. These places also
              include some of the best eateries that are available in the entire
              city of Kolkata. There are many modern as well as old stores that
              sell things that are of interest to everybody that visit these
              places. To choose one of these spaces head over to GoFloaters and
              book the space now.
              <br />
              <br />
            </p>
          </div>
        )
      if (props.locality === "Park Street")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Park Street, {props.city}
            </h4>
            <p>
              Park Street, officially known as Mother Teresa Sarani, is a famous
              thoroughfare in downtown Kolkata (formerly Calcutta), India. The
              street runs through what was a deer park of Sir Elijah Impey,
              Chief Justice of the Supreme Court in Calcutta from 1773 to 1789,
              hence the earlier name. Kolkata Municipal Corporation gave its
              current official name in honour of Mother Teresa. It’s in Central
              Kolkata. Park Street is home to the famous Football Club, Mohun
              Bagan FC, Cisco Systems, Wonderland and many other companies that
              are placed in this street use coworking spaces regularly. Since
              the rise of COVID, there has been a complete shift to working from
              home and the remote working space has seen an immense rise in its
              usage by many across the city. These spaces offer some of the best
              facilities that money can hire for a short period. Remote working
              is a concept that has been there for a while and it will be on the
              increase for the coming years. They provide the fastest Wi-Fi
              possible, hot desks, private meeting rooms to have meetings and
              discussions, TVs for presentations, projectors, etc. If you want
              to choose the space for yourself or the day, go to the GoFloaters
              application and book the space of your choice at your convenience
              and then show up to avail of some of the best facilities.
              <br />
              <br />
            </p>
          </div>
        )
    case "Ahmedabad":
      if (props.locality === "Vadodara")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Vadodara, {props.city}
            </h4>
            <p>
              Over 2.2 million people work here and there is only one place that
              all of them call home VADODARA! From being a retired people’s
              paradise to a college-going students’ hub, this city is one of the
              most diverse places in INDIA. It is also known as the cultural
              capital of Gujarat. Let us take a look at how this city has
              expanded over the years.
              <br />
              <br />
              There are a bunch of coworking and remote working spaces in and
              around Vadodara. Recently after the lockdown and the multiple
              covid waves, offices have decided to make sure that their
              employees are working from a proper place. They have then resorted
              to renting out coworking spaces across the city that is suitable
              for them and making sure that their people work from there. THE
              CO•WORK CAPITAL is one such place where co-working and remote
              working is highly promoted. Its nearness to the Notus IT park is a
              huge advantage for people who work in the IT Park.
              <br />
              <br />
              Most co-working spaces today have all the facilities that are
              required to meet the standards of modern-day users. Enjoy the
              uninterrupted working experience with high-speed internet and
              power backup. There is a whiteboard available for you to
              brainstorm and take notes on. Share your screen on the LED TV in
              the room. Share your screen on the projector in the room to enable
              your discussion. When you need to take a break there are
              refreshments available in the pantry. Free parking is available on
              a first-come first-serve basis. Copier and printer are also
              available for your work needs.
              <br />
              <br />
              With modern-day technologies that are provided in the coworking
              spaces across the city and many more things that are attached to
              these spaces it makes for a wonderful working experience. You can
              book these spaces at Rs 700 / hr. It is also available on a daily
              basis at Rs 6000 / day.
              <br />
              <br />
            </p>
          </div>
        )
    case "Madurai":
      if (props.locality === "")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>Coworking Spaces in Madurai</h4>
            <p>
              Madurai, the ancient and vibrant city is known as Thoonga Nagaram-
              'the sleepless city of India'. This is because the city is always
              swarmed with activities and 24 hours seems less. All day and night
              businesses, industries and various institutions keep the city
              awakened.
              <br />
              <br />
              Over the years, in addition to the historic reference to the city,
              Madurai has become one of the top locations for coworking and
              flexible work oppportunities. Even with limited options, Madurai
              still has some of the best coworking spaces in the region. In the
              last couple of years the city has seen a large reverse migrated
              population. The workforce are returning back to their hometowns.
              Entrepreneurial ventures, startups, IT and ITes professionals are
              getting home or finding their way back to Madurai to live in this
              agrarian and heritage city.
              <br />
              <br />
              Madurai is a major Tier II region for IT and Industry.
              <br />
              <br />
              Kapalua, which is a sub-urban of Madurai, is a business hub for
              automotive industries such as KUN BMW, Isuzu, Volkswagen, Toyota,
              Mahindra, Tata, Maruti Suzuki, Mitsubishi, Ashok Leyland, Jeep,
              Fiat India (FCA). Apart from these manufacturing units, there are
              many IT companies that have setup their offices in the city. There
              are around 5 co-working spaces in easily approachable locations
              and in and around the Meenakshi Amann Temple. <br />
              <br />
              There are many facilities that these spaces have. Fast Wi-fi,
              freshly brewed coffee from some of the finest restaurants being
              served to everybody, TVs, Projectors, Meeting rooms, dedicated
              parking spots, cubicles, hot desks and many more. <br />
              <br />
              Distributed remote hubs are common in Madurai. In the recent past,
              the city has also attracted many remote workers along with
              tourism, which has always been in full swing. This makes Madurai
              and ideal tranquil locations to work from anywhere with co-work
              and meeting spaces. In an ideal setting, making that impression
              during your meeting is especially important–be it within the team
              or with clientele. From a 2-person meeting room to 10+ seater
              meeting room, at GoFloaters you can find the perfect venue to make
              your meetings constructive and significant.
              <br />
              <br />
            </p>
          </div>
        )
    case "Visakhapatnam":
      if (props.locality === "")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Visakhapatnam
            </h4>
            <p>
              Visakhapatnam is a port city and industrial centre in the Indian
              state of Andhra Pradesh, on the Bay of Bengal. It’s known for its
              many beaches, including Ramakrishna Beach, home to a preserved
              submarine at the Kusura Submarine Museum. Nearby are the elaborate
              Kali Temple and the Visakha Museum, an old Dutch bungalow housing
              local maritime and historical exhibits.
              <br />
              <br />
              Waltair Main Road, Gurudwara Road and many more across the city
              has amazing coworking spaces which are used by a lot of IT
              professionals living and working in the city. They are easily
              accessible and have a lot of things to do in and around these
              areas, which is beneficial for the employees of the company.{" "}
              <br />
              <br />
              Being an IT Hub is difficult for any city. Just like that, Vizag
              has a lot of places where it is friendly to work from anywhere and
              make sure that there is no problem in doing so! These places are
              so efficient that you can use applications like GoFloaters to make
              or book a personalized space of your choice that you want at ease.
              These places have the best in class facilities such as TVs, Wi-Fi,
              and coffee that will keep you going throughout the day. Apart from
              the usual, they also have dedicated meeting rooms, hot desks and
              many other facilities that will help you connect, work and gain a
              different perspective in your work. <br />
              <br />
              To facilitate IT employees working from remote locations,
              Information Technology Minister Mekapati Goutham Reddy recently
              launched a State government’s Work from Hometown (W@HT) website.
              With W@HT centres across the State, the government aims to provide
              proper infrastructures, such as high-speed internet, uninterrupted
              power supply and dedicated work spaces, to IT and ITES employees/
              employers and freelancers who are working from home due to the
              Covid- 19 pandemic.
              <br />
              <br />
            </p>
          </div>
        )
    case "Lucknow":
      if (props.locality === "")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>Coworking Spaces in Lucknow</h4>
            <p>
              Some beautiful paths cannot be discovered without getting lost. If
              you believe in the maxim, you need to get lost to explore Lucknow
              and one of the ancient Indian cities. A cultural potboiler of
              food, music, art, and handicraft, Lucknow is a heritage city
              dating thousands of years back. The city has become a mine of
              interesting facts during its journey from the Sultanate Era till
              the present decade through the British Raj.
              <br />
              <br />
              Lucknow is a new and upcoming city where many coworking spaces are
              actively being used by people working in the city. Places such as
              Vishal Khand, Vibhuti Khand and many more, have some of the best
              coworking spaces that the city has ever seen. These places are
              equidistant to many of the companies and places of recreation for
              the employees after work as well. <br />
              <br />
              The facilities include dedicated parking spots, TVs, Projectors
              for presentations, dedicated meeting rooms for interviews and
              meetings, hot desks, Fast Wi-Fi, and many more such things that
              these coworking spaces provide to their valuable employees are
              just outstanding. <br />
              <br />
              It is a very safe city to live in since many multinational
              corporations are present and have set up their offices in the
              city! Lucknow is India’s first ‘CCTV City’. Initially, the
              cityscape was brought under the surveillance of 4000 CCTV cameras.
              They have doubled the number of cameras this year. Advanced drones
              are used to keep a watch on major areas during special occasions.
              To know more, you can check out the listing from our GoFloaters
              page.
              <br />
              <br />
            </p>
          </div>
        )
    case "Chandigarh":
      if (props.locality === "")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>
              Coworking Spaces in Chandigarh
            </h4>
            <p>
              Chandigarh is the capital of the state of Punjab where there are
              many prosperous industries and prominent companies that are
              present in the country. The state is rich for its diversity and
              the number of people it serves. It is also the capital of one of
              the 2 neighbouring states of Punjab and Haryana. With the increase
              of these industries and companies there has been a sharp increase
              in the coworking spaces in Chandigarh.
              <br />
              <br />
              Chandigarh is home to some of the best companies that India has
              ever produced. The city houses Webdew, Tech Mahindra, Infosys,
              IndiSoftware and many more. Keeping this in mind there are many
              meeting spaces in Chandigarh where people from the offices can use
              these spaces to run meetings outside of the workspace and many
              more. The co-working spaces in Chandigarh are located in prominent
              localities such Chandi Path, SDM Office Road, And near Butterfly
              park. <br />
              <br />
              Many of these locations have some of the best facilities that are
              there to provide. Fast Wi-Fi, TV’s for presentations, meeting
              spaces, dedicated hot desks, and many more. The coworking spaces
              in Chandigarh have a very nice ambience to them and they always
              make sure it is proper and correct at all times. These amenities
              also make it suitable as the Meeting Spaces on rent by the day or
              hour in Chandigarh.
              <br />
              <br />
              The startup culture in Chandigarh is picking up pace and due to
              COVID these last 2 years have been a blur in that increase. There
              are so many companies that completely moved to working from home
              and they have moved to working remotely. Companies like Simba
              Beer, Viprasoft and Just Herbs have completely moved to working
              from home and their employees use the meeting spaces or coworking
              spaces in Chandigarh at their own convenience. To book such
              coworking spaces in Chandigarh head over to the GoFloaters page
              and book now.
              <br />
              <br />
            </p>
          </div>
        )
    case "Nagpur":
      if (props.locality === "")
        return (
          <div className="col-md-12">
            <h4 style={{ fontWeight: "bold" }}>Coworking Spaces in Nagpur</h4>
            <p>
              Nagpur is the third-largest city in India and the winter capital
              of Maharashtra. It is the 13th largest city in India by
              population. Nagpur is an emerging metropolis. Nagpur's nominal GDP
              was estimated to be around ₹ 1,406,860 million in 2019-20, making
              it the largest economic centre in entire central India. Nagpur has
              many industries and startups that provide jobs to many in and
              around the city. It is home to the most famous snack manufacturer
              Haldirams. Nagpur is an upcoming 'smart city' of India. <br />
              <br />
              There are many coworking spaces in Nagpur mainly because there are
              many companies that have started or shifted to working remotely
              completely. Companies such as Prominent Information Technology
              companies such as TCS, Tech Mahindra, HCL, GlobalLogic, Persistent
              Systems and Hexaware are located at various IT parks in Nagpur.
              Since these companies have shifted to working from home, coworking
              spaces have thrived. Places such as Nehru Marg, Bus Stand Road,
              Narrow Guage Rail Museum and other places have coworking spaces
              located near them which is easily accessible for many people who
              work in the area.
              <br />
              <br />
              The corporate shift to hybrid and remote work models has made
              Nagpur, a sought after location for coworking. Coworking players
              are eyeing the Tier 2 & 3 cities such as Nagpur to double their
              space for coworking in Nagpur and providing meeting space in
              Nagpur. <br />
              <br />
              The workspaces have best of amenities required for individual,
              working, meeting teams' or pitch presentation or casual day of
              work. <br />
              <br />
              Nagpur is the educational and commercial hub of the region. The
              city gets massive support for innovations via grants and
              opportunities from the State Government of Maharashtra. <br />
              <br />
              Saas, Foodtech, Edtech, and Manufacturing are some of the
              industries that are being explored by the startup and young
              entrepreneurs of Nagpur.
              <br />
              <br />
              Nagpur is also now slowly transforming into an ideal destination
              for independent consultants and freelancers with its idyllic
              location and lower cost of living when compared to urban cities.{" "}
              <br />
              <br />
              Coworking and remote working spaces in Nagpur seem to provide
              networking opportunity and ambiance to ideate and innovate further
              for the developments. <br />
              <br />
              So, if you want to book an inspirational space to cowork in
              Nagpur, then GoFloaters is the right choice for you. Log in to the
              application and choose the space of your choice today.
            </p>
          </div>
        )

    default:
      return <div className="col-md-12"></div>
  }
}
